import moment from "moment";
import React, { useRef, useEffect, useState } from "react";
import styles from "./DetailTestView.module.css";
import ViewBookSet from "../BookModule/BookModule.module.css";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../labels";
// import Swal from "sweetalert2";
import QuerySection from "../Faculty/StudentsQuery/QuerySection";
import ExplanationQuery from "../Faculty/StudentsQuery/ExplanationQuery";
import RtypeOne from "../StudentTestWorkflow/RtypeOne";
// import { multiCusutomStyle } from "../../../../pages/Multicustomstyles";
// import { CustomCOption } from "../../../../labels/Lableoption";
import Select, { components } from "react-select";
// import { customStyles } from "../../../../pages/customStyles";
import PublicResult from "./PublishResults/PublicResult";
// import IconDownload from "@mui/icons-material/FileDownload";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import RtypeTwo from "../StudentTestWorkflow/RtypeTwo";
import RtypeThree from "../StudentTestWorkflow/RtypeThree";
import RtypeFour from "../StudentTestWorkflow/RtypeFour";
import RtypeParaOption from "../StudentTestWorkflow/RtypeParaOption";
import Rtypepara from "../StudentTestWorkflow/Rtypepara";
import RtypeTen from "../StudentTestWorkflow/RtypeTen";
import RtypeNine from "../StudentTestWorkflow/RtypeNine";
import RtypeEight from "../StudentTestWorkflow/RtypeEight";
import RtypeSeven from "../StudentTestWorkflow/RtypeSeven";
import RtypeSix from "../StudentTestWorkflow/RtypeSix";
import RtypeFive from "../StudentTestWorkflow/RtypeFive";
import {
  // ConnectingAirportsOutlined,
  Search,
  // Visibility,
} from "@mui/icons-material";
// import DownloadIcon from "@mui/icons-material/Download";
import Loader from "../../Loader";
// import CustomDropdown from "../../../ReusuableComponent/Dropdown/CustomDropdown";
import DescriptivePublishResults from "./PublishResults/DescriptivePublishResults";
// import DatePickerModel from "./Descriptive/DatePickerModel/DatePickerModel";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import { apiGetAllSupervisors } from "../../../../services/services";
// import DatePickerModel from "./Descriptive/DatePickerModel/DatePickerModel";
import DatePickerSample from "../../DatePicker";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";
import axios from "axios";
import fileDownload from "js-file-download";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { getAccessToken } from "../../../../labels/msalConfig";
import { Client } from "@microsoft/microsoft-graph-client";

export default function DetailTestView() {
  const [showPublicResults, setShowPublicResults] = useState(false);
  const [showDOpModel, setShowDOpModel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const handlePublicResults = () => {
    setShowPublicResults(true);
  };

  const handleDescriptivePublicResults = () => {
    setShowDOpModel(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let currentTime = moment();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    CATEGORY,
    COURSE,
    SUBJECT,
    TESTTOPIC,
    TIME,
    STATUS,
    SEARCHTERM,
    EVENTTYPE,
    ACTIVE_TAB,
    EVENT_TYPE,
  } = location.state || {};

  const { id, type } = useParams();
  const [studResponse, setStudResponse] = useState([]);
  const [resData, setResData] = useState("");

  const [dropdownValue1, setDropdownValue1] = useState(null);
  const [dropdownValue2, setDropdownValue2] = useState(null);
  const txtBSearch = useRef(null);
  const filterRef_batch_name = useRef(null);
  const txtBSearch_batch_name = useRef(null);
  const answer_sheet_ref = useRef(null);
  const filterRef_section = useRef(null);
  const filterRef_class_mode = useRef(null);
  const filterRef_medium = useRef(null);
  const filterRef_schedule = useRef(null);
  const filterRef_location = useRef(null);
  const filterRef_status = useRef(null);
  const filterRef = useRef(null);
  const filterRefAssign = useRef(null);
  const filterRefEvaluate = useRef(null);

  const txtEvDuedate = useRef(null);
  const txtEvTDuedate = useRef(null);
  const [staff_find_id, setStaff_find_id] = useState("");
  const [batch_name, setBatch_name] = useState([]);
  const [flagReload, setFlagReload] = useState(false);
  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditStaff, setIsEditStaff] = useState(false);
  const txtAssignTo = useRef(null);
  const txtAdDjoin = useRef(null);
  const [filteredData, setFilteredData] = useState([]);

  const [assignStatus, setAssignStatus] = useState([]);
  const [evaluateStatus, setEvaluateStatus] = useState([]);

  // const [error, setError] = useState({});
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let user_type = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      user_type = user.user_type;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  // get staff teaching list
  useEffect(() => {
    AxiosInstance.post("api/all/getTeachingStaffList")
      .then((res) => {
        const staffMmem = res.data.data.map((item, index) => ({
          value: item.user_id, // faculty user id
          label: item.full_name,
          staff_id: item.staff_id,
        }));
        setStaffMem(staffMmem);
      })
      .catch((error) => {
        return error;
      });
  }, []);
  // find by call
  useEffect(() => {
    findById(id);
  }, []);
  // query raise flag update
  useEffect(() => {
    findById(id);
  }, [flagReload]);

  let typeStatus = [];
  let typeStatus1 = [];
  let filterSearch = [];
  let filterBatchName = [];
  let filterSection = [];
  let filterClassMode = [];
  let filterSchedule = [];
  let filterLocation = [];
  let filterMedium = [];
  assignStatus.map((obj) => {
    typeStatus.push(obj.id);
  });
  evaluateStatus.map((obj) => {
    typeStatus1.push(obj.id);
  });
  // find by id functionality
  const findById = (idss) => {
    setIsLoading(true);
    AxiosInstance.post("api/event/findById", {
      id: parseInt(idss),
      due_date_start_date: appOn.length > 0 ? appOn[0].fdate + " 00:00:00" : "",
      due_date_end_date: appOn.length > 0 ? appOn[0].edate + " 23:59:00" : "",
      event_type: EVENTTYPE,
      assign_status:
        typeStatus.length > 0 && typeStatus.length < 2 ? typeStatus[0] : "",
      evaluation_status:
        typeStatus1.length > 0 && typeStatus1.length < 2 ? typeStatus1[0] : "",
    })
      .then((res) => {
        // console.log(res);
        if (res.data.status === true) {
          setIsLoading(false);
          let el = res.data.data;
          setResData(el);
          // evaluvator list data
          const studentLists = res.data.data.student_list;
          setStudResponse(studentLists);
          const staffEvaluvatorList = res.data.data.staff_list;
          setFilteredData(staffEvaluvatorList);
          // student data

          setFdata((prevFdata) => ({
            ...prevFdata,
            title: el.name,
            sDate:
              el.start_date !== null
                ? moment(el.start_date).format("YYYY/MM/DD")
                : "",
            startTime: el.start_time,
            endTime: el.end_time,
            subject: el.subject,
            publish_results: el.publish_results,
            staff_name: el.staff_name,
            description: el.description,
            batchName: el.batch_name,
            category: el.category,
            syllabus_path: el.syllabus_filepath,
            course: el.category_class,
            method_of_test: el.method_of_test,
            double_evaluation: el.double_evaluation,
            que_status: el.que_status,
            classMode: el.class_mode,
            medium: el.medium,
            location: el.location,
            teams_url: el.teams_url,
            batch_id: el.batch_id,
            cutOff: el.cut_off,
            event_id: el.id,
            batch_types: el.type,
            event_type: el.event_type,
            staff_description: el.staff_description,
            recording_url: el.recording_url,
            attendance_sheet_path: el.attendance_sheet_frame,
            original_attendancesheet_file_path:
              el.original_attendancesheet_file_path,
            // test_num: el.test_no,
            test_topic: el.test_topic,
            tol_mark: el.tot_marks,
            no_ques: el.no_of_questions,
            qpath: el.que_paper_filepath,
            qpath_original_path: el.original_que_paper_filepath,
            answer_booklet_original_path: el.answer_booklet_original_path
              ? el.answer_booklet_original_path
              : null,
            answer_booklet_path: el.answer_booklet_path
              ? el.answer_booklet_path
              : null,
            question_frameset_path: el.question_frame_path
              ? el.question_frame_path
              : null,
            question_frameset_original_path: el.question_frame_original_path
              ? el.question_frame_original_path
              : null,
            answer_key_path: el.answer_key_path ? el.answer_key_path : null,
            answer_key_original_path: el.answer_key_original_path
              ? el.answer_key_original_path
              : null,
          }));

          const subTopics =
            el.subject_test_topics && el.subject_test_topics.length > 0
              ? el.subject_test_topics
              : [];

          setSubTopic(subTopics);
          const SubOtherApplic =
            el.oth_app_batch && el.oth_app_batch.length > 0
              ? el.oth_app_batch
              : [];
          setOtherApplic(SubOtherApplic);

          const SubOtherCombinedTest =
            el.combine_name && el.combine_name.length > 0
              ? el.combine_name
              : [];
          setCombineTest(SubOtherCombinedTest);

          let que_spaperinfo =
            res.data.data.que_pap_info.length > 0
              ? res.data.data.que_pap_info
              : [];

          const transformedData = que_spaperinfo.map((item) => {
            const { subject, no_of_ques, difficulty_type } = item;
            const difficulty = difficulty_type[0];
            // console.log(difficulty, "difficulty");
            return {
              subject,
              no_ques: no_of_ques,
              very_easy_ques: difficulty.hasOwnProperty("1")
                ? difficulty["1"]
                : "_",
              easy_ques: difficulty.hasOwnProperty("0") ? difficulty["0"] : "_",
              med_ques: difficulty.hasOwnProperty("4") ? difficulty["4"] : "_",
              hard_ques: difficulty.hasOwnProperty("2") ? difficulty["2"] : "_",
              very_hard_ques: difficulty.hasOwnProperty("3")
                ? difficulty["3"]
                : "_",
              medium: subject,
            };
          });

          setQuesdata(transformedData);

          const query_section =
            el.query.length > 0
              ? el.query.map((query) => ({
                ...query,
                query_status:
                  query.assignee_info &&
                    query.assignee_info.query_status === 0
                    ? "0"
                    : "1",
                query_path:
                  query.assignee_info &&
                    query.assignee_info.query_proof_filepath
                    ? query.assignee_info.query_proof_filepath
                    : null,
                reply_query:
                  query.assignee_info && query.assignee_info.reply_by_staff
                    ? query.assignee_info.reply_by_staff
                    : "",
                original_query_path:
                  query.assignee_info &&
                    query.assignee_info.original_query_filepath
                    ? query.assignee_info.original_query_filepath
                    : "",
                query_Status_error: "",
                query_path_error: null,
                reply_status_error: "",
                isEdit: false,
                IsUpdate: false,
                IsFacultyEdit: false,
                IsfacultyUpdate:
                  query.assignee_info && query.assignee_info.reply_by_staff
                    ? query.assignee_info.reply_by_staff
                      ? true
                      : false
                    : "",
                IsFaculty_id:
                  query.assignee_info && query.assignee_info.assigned_to
                    ? query.assignee_info.assigned_to
                    : null,
                isFaculty_name:
                  query.assignee_info && query.assignee_info.assigned_to_name
                    ? query.assignee_info.assigned_to_name
                    : "",
                isFaculty_error: "",
                query_stage:
                  query.assignee_info && query.assignee_info.query_stage
                    ? query.assignee_info.query_stage
                    : 0,
              }))
              : [];
          setViewQueries(query_section);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  };
  const loadListdata = () => {
    let tempbatch = [];
    let tempsection = [];
    let tempmedium = [];
    let tempclassMode = [];
    let tempSchedule = [];
    let templocation = [];
    let tempstatus = [];
    batch_name.map((obj) => {
      tempbatch.push(obj.name);
    });
    section.map((obj) => {
      tempsection.push(obj.name);
    });
    medium_on.map((obj) => {
      tempmedium.push(obj.name);
    });
    classMode.map((obj) => {
      tempclassMode.push(obj.name);
    });
    schedule.map((obj) => {
      tempSchedule.push(obj.name);
    });
    locations.map((obj) => {
      templocation.push(obj.name);
    });
    status_on.map((obj) => {
      tempstatus.push(Number(obj.id));
    });
    const filters = {
      search: searchTerm.length > 0 ? searchTerm : "",
      event_id: id,
      batch_name: batch_name.length > 0 ? tempbatch : "",
      section: section.length > 0 ? tempsection : "",
      medium: medium_on.length > 0 ? tempmedium : "",
      class_mode: classMode.length > 0 ? tempclassMode : "",
      batch_type: schedule.length > 0 ? tempSchedule : "",
      location: locations.length > 0 ? templocation : "",
      status: status_on.length > 0 ? tempstatus : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/test/class/class_attend", filters)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setCurrentPage(1);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setUpdateListData(serialNumberAddedData);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            name: item.name,
            email: item.email,
            phone_no: item.phone_no,
            batch_name: item.batch_name,
            section: item.section,
            medium: item.medium,
            class_mode: item.class_mode,
            batch_type: item.batch_type,
            location: item.location,
            status: item.status == 0 ? "Absent" : "Present",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        console.error("Error loading data:", error);
      });
  };
  const [csvData, setCsvData] = useState([]);
  const [subTopic, setSubTopic] = useState([]);
  const [otherApplic, setOtherApplic] = useState([]);
  const [section, setSection] = useState([]);
  const [medium, setMedium] = useState([]);
  const [classMode, setClassMode] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [combineTest, setCombineTest] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [locationsId, setlocationsId] = useState([]);

  const [quesdata, setQuesdata] = useState({});
  const [staffMem, setStaffMem] = useState([]);
  const [locations, setLocations] = useState([]);
  const [batchList, setBatchList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [selectedStaffMem, setSelectedStaffMem] = useState([]);
  const txtQueryStatus = useRef(null);
  const txtQueryPath = useRef(null);
  const txtQueryReply = useRef(null);

  const [viewQueries, setViewQueries] = useState([]);

  // details list data
  const [fdata, setFdata] = useState({
    title: "",
    // test_no: "",
    sDate: "",
    batch_types: "",
    startTime: "",
    endTime: "",
    subject: "",
    staff_name: "",
    description: "",
    batchName: "",
    category: "",
    course: "",
    method_of_test: "",
    que_status: "",
    classMode: "",
    medium: "",
    location: "",
    syllabus_path: null,
    teams_url: "",
    batch_id: "",
    event_id: "",
    test_num: "",
    test_topic: "",
    tol_mark: "",
    no_ques: "",
    qpath: null,
    qpath_original_path: null,
    answer_booklet_original_path: null,
    answer_booklet_path: null,
    question_frameset_path: null,
    question_frameset_original_path: null,
    answer_key_path: null,
    answer_key_original_path: null,
    assign_to: "",
    assign_to_name: "",
    event_type: "",
    cutOff: "",
    publish_results: null,
    double_evaluation: null,
  });

  // upload question file
  const Upload_Question = () => {
    navigate(`/UploadQuestionFile/${fdata.method_of_test == 0 ? 1 : 0}`, {
      state: {
        id,
        status,
      },
    });
  };

  const handleNavigate = (
    isSameDayss,
    isAfterStartTimesss,
    isAfterStartDatess
  ) => {
    const eventName = fdata.title;
    const bachId = fdata.batch_id;
    const publish_results = fdata.publish_results;
    const Isdisabled =
      (isSameDayss && isAfterStartTimesss) || isAfterStartDatess;

    navigate("/ViewQuestionPaper", {
      state: {
        id,
        status,
        eventName,
        bachId,
        publish_results,
        Isdisabled,
      },
    });
  };

  // ------chipdata listitem------
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  const handleflagReload = () => {
    setFlagReload(true);
    setShowPublicResults(false);
  };
  const handleClose_descriptive = () => {
    setTimeout(() => {
      setShowDOpModel(false);
    }, 100);
    setFlagReload(!flagReload);
  };
  // Add useEffect to check when showDOpModel changes
  useEffect(() => { }, [showDOpModel]);
  // query assign
  const handleAssign = (option, dname, questionPk) => {
    // console.log(option, "option");
    if (option) {
      setViewQueries((prevState) => {
        return prevState.map((q) => {
          if (q.question_pk === questionPk) {
            return {
              ...q,
              IsFaculty_id: option.value,
              isFaculty_name: option.label,
              isFaculty_error: "",
            };
          }
          return q;
        });
      });
    } else {
      setViewQueries((prevState) => {
        return prevState.map((q) => {
          if (q.question_pk === questionPk) {
            return {
              ...q,
              IsFaculty_id: "",
              isFaculty_name: "",
              isFaculty_error: "",
            };
          }
          return q;
        });
      });
    }
  };
  // validate assign to dropdown
  const validateAssignTo = (queries, pk) => {
    const UpdateReplyss = queries.map((OB) => {
      // console.log(OB, "Adasdadasd");
      let updatedOB = { ...OB };
      if (!OB.IsFaculty_id && !OB.isFaculty_name && OB.question_pk === pk) {
        updatedOB.isFaculty_error = "Please select faculty ";
      }
      return updatedOB;
    });

    setViewQueries(UpdateReplyss);
  };
  // query assign to faculty
  const handleAssignTo = (elements) => {
    validateAssignTo(viewQueries, elements.question_pk);
    if (
      viewQueries.length > 0 &&
      viewQueries.find(
        (el) =>
          el.isFaculty_error === "" &&
          el.IsFaculty_id !== "" &&
          el.isFaculty_name !== "" &&
          el.question_pk === elements.question_pk
      )
    ) {
      const df = {
        user_type: 0, // admin assign to deafult user_type  0→admin, 1→faculty
        event_type: fdata.event_type ? fdata.event_type : 1, // default as test so event type 1
        event_pk: fdata.event_id ? fdata.event_id : "",
        batch_pk: fdata.batch_id ? fdata.batch_id : "",
        question_pk: elements.question_pk,
        // rquery_pk:
        //   elements.stud_query && elements.stud_query.length > 0
        //     ? elements.stud_query.map((el) => el.pk)
        //     : null,
        remaind_again: 0,
        assigned_to: elements.IsFaculty_id ? elements.IsFaculty_id : "",
        assigned_by: userid, // admin_user id
        query_status: 0, // 0 valid 1 invalid
        query_proof_filepath: "",
        original_query_filepath: "",
        reply_by_staff: null,
        query_stage: 0, // 0 others 1 approved
        query_approved_dt: null,
        created_by: userid,
        updated_by: userid,
      };

      if (df.assigned_to !== "") {
        RaiseAdminQuery(df);
        setViewQueries((prevState) => {
          return prevState.map((q) => {
            if (q.question_pk === elements.question_pk) {
              return {
                ...q,
                isEdit: false,
              };
            }
            return q;
          });
        });
        // setFlagReload(true);
      }
    }
  };

  // query reply validation

  const validateQueryReply = (queries) => {
    const UpdateReplyss = queries.map((OB) => {
      // console.log(OB, "sdsfsdf");
      let updatedOB = { ...OB };
      if (!OB.query_status) {
        updatedOB.query_Status_error = "Please select query status";
      }
      if (OB.query_path === null) {
        updatedOB.query_path_error = "Please select query path";
      }
      if (!OB.reply_query) {
        updatedOB.reply_status_error = "Please enter reply ";
      }

      if (!OB.isFaculty_error) {
        updatedOB.isFaculty_error = "Please select faculty ";
      }

      return updatedOB;
    });

    setViewQueries(UpdateReplyss);
  };

  // query approve
  const handleUpdateApprove = (elements) => {
    validateQueryReply(viewQueries);
    if (
      viewQueries.length > 0 &&
      viewQueries.every(
        (el) =>
          el.query_Status_error === "" &&
          (el.query_path_error === "" || el.query_path_error === null) &&
          el.reply_status_error === ""
      )
    ) {
      const df = {
        user_type: 0, // admin assign to deafult user_type  0→admin, 1→faculty
        event_type: fdata.event_type ? fdata.event_type : 1, // default as test so event type 1
        event_pk: fdata.event_id ? fdata.event_id : "",
        batch_pk: fdata.batch_id ? fdata.batch_id : "",
        question_pk: elements.question_pk,
        remaind_again: 0,
        assigned_to: elements.IsFaculty_id ? elements.IsFaculty_id : "",
        assigned_by: userid, // admin_user id
        query_status: elements.query_status, // 0 valid 1 invalid
        query_proof_filepath: elements.query_path,
        original_query_filepath: elements.original_query_path,
        reply_by_staff: elements.reply_query,
        // rquery_pk:
        //   elements.stud_query && elements.stud_query.length > 0
        //     ? elements.stud_query.map((el) => el.pk)
        //     : null,
        query_stage: 1, // 0 others 1 approved
        query_approved_dt: moment().format("YYYY/MM/DD HH:mm:ss"),
        created_by: userid,
        updated_by: userid,
      };
      if (elements.reply_query !== "" && elements.query_status !== "") {
        RaiseAdminQuery(df);
      }
      setViewQueries((prevState) => {
        return prevState.map((q) => {
          if (q.question_pk === elements.question_pk) {
            return {
              ...q,
              isUpdate: false,
              isEdit: false,
              IsFacultyEdit: false,
              IsfacultyUpdate: true,
            };
          }
          return q;
        });
      });
    }
  };

  // query remind me again
  const handleRemindMeAgain = (elements) => {
    const df = {
      user_type: 0, // admin assign to deafult user_type  0→admin, 1→faculty
      event_type: fdata.event_type ? fdata.event_type : 1, // default as test so event type 1
      event_pk: fdata.event_id ? fdata.event_id : "",
      batch_pk: fdata.batch_id ? fdata.batch_id : "",
      question_pk: elements.question_pk,
      remaind_again: 1,
      assigned_to: elements.IsFaculty_id ? elements.IsFaculty_id : "",
      assigned_by: userid, // admin_user id
      query_status: 0, // 0 valid 1 invalid
      query_proof_filepath: "",
      original_query_filepath: "",
      reply_by_staff: null,
      // rquery_pk:
      //   elements.stud_query && elements.stud_query.length > 0
      //     ? elements.stud_query.map((el) => el.pk)
      //     : null,
      query_stage: 0, // 0 others 1 approved
      query_approved_dt: null,
      created_by: userid,
      updated_by: userid,
    };
    RaiseAdminQuery(df);
  };

  // approve handle
  const handleApprove = (elements) => {
    const df = {
      user_type: 0, // admin assign to deafult user_type  0→admin, 1→faculty
      event_type: fdata.event_type ? fdata.event_type : 1, // default as test so event type 1
      event_pk: fdata.event_id ? fdata.event_id : "",
      batch_pk: fdata.batch_id ? fdata.batch_id : "",
      question_pk: elements.question_pk,
      remaind_again: 0,
      assigned_to: elements.IsFaculty_id ? elements.IsFaculty_id : "",
      assigned_by: userid, // admin_user id
      query_status: elements.query_status, // 0 valid 1 invalid
      query_proof_filepath: elements.query_path,
      original_query_filepath: elements.original_query_path,
      reply_by_staff: elements.reply_query,
      query_stage: 1, // 0 others 1 approved
      query_approved_dt: moment().format("YYYY/MM/DD HH:mm:ss"),
      created_by: userid,
      // rquery_pk:
      //   elements.stud_query && elements.stud_query.length > 0
      //     ? elements.stud_query.map((el) => el.pk)
      //     : null,
      updated_by: userid,
    };
    if (elements.reply_query !== "" && elements.query_status !== "") {
      RaiseAdminQuery(df);
    }
    // setViewQueries((prevState) => {
    //   return prevState.map((q) => {
    //     if (q.question_pk === elements.question_pk) {
    //       return {
    //         ...q,
    //         isUpdate: false,
    //         isEdit: false,
    //         IsFacultyEdit: false,
    //         IsfacultyUpdate: false,
    //       };
    //     }
    //     return q;
    //   });
    // });
  };
  // edit query assgin
  const handleEditAssignTo = (el) => {
    setViewQueries((prevState) => {
      return prevState.map((q) => {
        if (q.question_pk === el.question_pk) {
          return {
            ...q,
            isEdit: true,
            IsfacultyUpdate: false,
            IsFacultyEdit: false,
          };
        }
        return q;
      });
    });
  };

  const handleEditFaculty = (el) => {
    setViewQueries((prevState) => {
      return prevState.map((q) => {
        if (q.question_pk === el.question_pk) {
          return {
            ...q,
            isUpdate: false,
            isEdit: false,
            IsFacultyEdit: true,
            IsfacultyUpdate: false,
          };
        }
        return q;
      });
    });
  };

  const RaiseAdminQuery = (dff) => {
    AxiosInstance.post("api/test/raise/query/byAdmin", dff)
      .then((response) => {
        if (response.data.status) {
          setFlagReload(!flagReload);
          toast.success(response.data.message);
        } else {
          setFlagReload(false);
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const handleChange = (event, elements) => {
    const { name, value, files, checked } = event.target;
    if (name === "query_path" && files && files.length > 0) {
      // console.log(value);
      const query_file = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("query_file", query_file);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setViewQueries((prevState) => {
                return prevState.map((q) => {
                  if (q.question_pk === elements.question_pk) {
                    return {
                      ...q,
                      query_path: res.data.path,
                      original_query_path: res.data.originalname,
                      query_path_error: "",
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setViewQueries((prevState) => {
            return prevState.map((q) => {
              if (q.question_pk === elements.question_pk) {
                return { ...q, query_path_error: err };
              }
              return q;
            });
          });
        }
      } else {
        let err = "pdf files only allowed";
        setViewQueries((prevState) => {
          return prevState.map((q) => {
            if (q.question_pk === elements.question_pk) {
              return { ...q, query_path_error: err };
            }
            return q;
          });
        });
      }
    } else if (name === "query_status") {
      setViewQueries((prevState) => {
        return prevState.map((q) => {
          if (q.question_pk === elements.question_pk) {
            return { ...q, query_status: value, query_Status_error: "" };
          }
          return q;
        });
      });
      setError({
        ...error,
        [name]: "",
      });
    } else if (name === "reply_query") {
      setViewQueries((prevState) => {
        return prevState.map((q) => {
          if (q.question_pk === elements.question_pk) {
            return { ...q, reply_query: value, reply_status_error: "" };
          }
          return q;
        });
      });
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const handleChange1 = (event) => {
    let { name, files, value } = event.target;
    if (name === "AttendancesheetPath") {
      if (files && files.length > 0) {
        const attendancesheet = files[0];
        setFdata((prevState) => ({
          ...prevState,
          AttendancesheetPath: null,
          answer_sheet_original_path: null,
        }));
        const allowedMimeTypes = ["text/csv", "application/vnd.ms-excel"];

        // Validate file type
        if (allowedMimeTypes.includes(files[0].type)) {
          // Validate file size (less than 10MB)
          if (files[0].size < 10 * 1024 * 1024) {
            const formData = new FormData();
            formData.append("attendancesheet", attendancesheet);

            // First API call
            AxiosInstance.post("/api/upload/", formData)
              .then((res) => {
                setFdata((prevState) => ({
                  ...prevState,
                  AttendancesheetPath: res.data.path,
                  answer_sheet_original_path: res.data.originalname,
                }));

                setError({
                  ...error,
                  AttendancesheetPath: "",
                });
              })
              .catch((error) => {
                console.error("Error in first API call:", error);
              });
          } else {
            let err = "File size must be less than 10MB.";
            setError({
              ...error,
              AttendancesheetPath: err,
            });
            setFdata((prevState) => ({
              ...prevState,
              AttendancesheetPath: null,
              question_f_original_path: null,
            }));
          }
        } else {
          // Handle invalid file type (e.g., PDF or other)
          let err = " CSV files only allowed.";
          setError({
            ...error,
            AttendancesheetPath: err,
          });
          setFdata((prevState) => ({
            ...prevState,
            AttendancesheetPath: null,
            answer_sheet_original_path: null,
          }));
        }
      } else {
        setFdata((prevState) => ({
          ...prevState,
          AttendancesheetPath: null,
          answer_sheet_original_path: null,
        }));
      }
    }
    // Update state
    setFdata((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };
  const handleCancel = (el) => {
    setViewQueries((prevState) => {
      return prevState.map((q) => {
        if (q.question_pk === el.question_pk) {
          return {
            ...q,
            isUpdate: true,
            isEdit: false,
            IsfacultyUpdate: true,
            IsFacultyEdit: false,
          };
        }
        return q;
      });
    });
  };
  const handleAllClear = () => {
    setAssignStatus([]);
    setEvaluateStatus([]);
    setUpdateChipData([]);
  };
  //chips overall clear button
  const handleAllClears = () => {
    setAppOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setUpdateChipDatas([]);
  };
  const handleAllClear1 = () => {
    setSearchTerm([]);
    setBatch_name([]);
    setSection([]);
    setMedium_on([]);
    setClassMode([]);
    setSchedule([]);
    setLocations([]);
    setStatus_on([]);
    setUpdateChipData1([]);
  };
  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "assignStatus") {
      setAssignStatus(
        assignStatus.filter((item) => item.id !== chipToDelete.id)
      );
      filterAssignStatus = assignStatus.filter(
        (item) => item.id !== chipToDelete.id
      );
    }
    if (chipToDelete.type === "evaluateStatus") {
      setEvaluateStatus(
        evaluateStatus.filter((item) => item.id !== chipToDelete.id)
      );
      filterEvaluateStatus = assignStatus.filter(
        (item) => item.id !== chipToDelete.id
      );
    }
    loadChipdata();
  };
  const handleDeletes = (chipToDelete, index) => () => {
    updateStateDatas();

    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setAppOn([]);
    filterApplyed = [];
    loadChipdatas();
  };
  const handleDelete1 = (chipToDelete, index) => () => {
    updateStateData1();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "batch_name") {
      setBatch_name(batch_name.filter((item) => item.id !== chipToDelete.id));
      filterBatchName = batch_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "section") {
      setSection(section.filter((item) => item.id !== chipToDelete.id));
      filterSection = section.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
      filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "class_mode") {
      setClassMode(classMode.filter((item) => item.id !== chipToDelete.id));
      filterClassMode = classMode.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "schedule") {
      setSchedule(schedule.filter((item) => item.id !== chipToDelete.id));
      filterSchedule = schedule.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "location") {
      setLocations(locations.filter((item) => item.id !== chipToDelete.id));
      filterLocation = locations.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "status") {
      setStatus_on(status_on.filter((item) => item.id !== chipToDelete.id));
      filterStatus1 = status_on.filter((item) => item.id !== chipToDelete.id);
    }
    loadChipdata1();
  };
  // Parse the start date and end time
  const startDate = moment(fdata.sDate, "YYYY-MM-DD");
  const endTime = moment(fdata.endTime, "HH:mm:ss");
  const startTime = moment(fdata.startTime, "HH:mm:ss");
  // Combine the current date with the end time to get the correct endDateTime
  const endDateTime = moment(
    `${currentTime.format("YYYY-MM-DD")} ${endTime.format("HH:mm:ss")}`,
    "YYYY-MM-DD HH:mm:ss"
  );

  const StartDateTime = moment(
    `${currentTime.format("YYYY-MM-DD")} ${startTime.format("HH:mm:ss")}`,
    "YYYY-MM-DD HH:mm:ss"
  );

  // Check if current time is on the same day as start date and after the end time
  const isSameDay = currentTime.isSame(startDate, "day");
  const isAfterEndTime = currentTime.isAfter(endDateTime);
  // for descriptive given one hour for answer sheet upload time
  const isAfterEndTimeONEHOUR =
    !isSameDay ||
    (isSameDay && currentTime.isAfter(endDateTime.clone().add(1, "hour")));
  const isAfterStartTime = currentTime.isAfter(StartDateTime);
  const isAfterStartDate = currentTime.isAfter(startDate, "day");

  // view Test List
  let page = R_PER_PAGE;
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabName, setActiveTabName] = useState("TNPSC");
  const [sortOrder, setSortOrder] = useState("desc");
  const [isOpen, setIsOpen] = useState({
    dueDate: false,
    status: false,
    evaluateStatus: false,
    assignStatus: false,
    batch_name: false,
    section: false,
    medium: false,
    class_mode: false,
    schedule: false,
    location: false,
  });

  const assignStausId = assignStatus.map((item) => {
    return item.id;
  });

  const [status, setStatus] = useState([]);
  const [status_on, setStatus_on] = useState([]);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);

  const [open_doubleeva, setOpen_doubleeva] = useState(false);
  const [numOfAnsSheet, numOfAnsSheetSetStatus] = useState([]);
  const [openPDModal, setOpenPDModal] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [rowsPerPage1, setRowsPerPage1] = useState(page);
  const [currentPage1, setCurrentPage1] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const [updateListData, setUpdateListData] = useState();

  const [rowsPerPages, setRowsPerPages] = useState(page);
  const [currentPages, setCurrentPages] = useState(1);

  const [evaluatorList, setEvaluatorList] = useState("");
  const [statusRetained, setStatusRetained] = useState(false);
  const [statusRetained1, setStatusRetained1] = useState(false);
  const [evaluatorList1, setEvaluatorList1] = useState([]);

  const [evaluatorList2, setEvaluatorList2] = useState([]);
  const Staff_duedate =
    evaluatorList?.length > 0 &&
    evaluatorList?.map((item) => {
      return item.due_date;
    });
  const Staff_duedate1 =
    evaluatorList1?.length > 0 &&
    evaluatorList1?.map((item) => {
      return item.due_date;
    });

  const due_dates = Staff_duedate[0]
    ? new Date(Staff_duedate[0]).toISOString().split("T")[0]
    : "Invalid Date";

  const due_dates1 = Staff_duedate1[0]
    ? new Date(Staff_duedate1[0]).toISOString().split("T")[0]
    : "Invalid Date";
  const [list, setList] = useState({
    eventDate: "",
    eventDate1: "", // for single evaluation
    eventDate2: "",
  });
  useEffect(() => {
    if (due_dates !== "Invalid Date") {
      setList((prevState) => ({
        ...prevState,
        eventDate: due_dates,
      }));
    }
  }, [due_dates]);

  useEffect(() => {
    if (due_dates1 !== "Invalid Date") {
      setList((prevState) => ({
        ...prevState,
        eventDate1: due_dates1,
      }));
    }
  }, [due_dates1]);

  const handleTabClick = (tabIndex, name) => {
    setActiveTab(tabIndex);
    setCurrentPage(1);
    setActiveTabName(name);
    setSelectedStudents([]);
    setUpdateChipData([]);
    setAssignStatus([]);
    setEvaluateStatus([]);
  };

  const totalPages = Math.ceil(
    studResponse?.flatMap((item) => item.student_list)?.length / rowsPerPage
  );
  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_batch_name.current) {
        txtBSearch_batch_name.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_batch_name.current.dispatchEvent(event);
      }
    }
  };
  const handleFilterCourseSearch = (event, names) => {
    if (names == "batch_name") {
      const searchInput = event.target.value;

      if (searchInput !== "") {
        const matchingObjects = batchList.filter(
          (item) =>
            item.batch_name &&
            item.batch_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        setBatchList(matchingObjects);
      } else {
        setBatchList(batchList);
      }
    }
  };
  const totalPages1 = Math.ceil(updateListData?.length / rowsPerPage1);

  const totalPages_de = Math.ceil(filteredData?.length / rowsPerPages);

  const handleSort = (event, sortKey, name) => {
    event.preventDefault();
    if (name === "evList") {
      let order =
        sortOrder === "asc" ? "desc" : sortOrder === "desc" ? "asc" : "desc";
      setSortOrder(order);
      let sortedList = filteredData.sort((a, b) => {
        const aValue = a[sortKey]?.toString().toLowerCase() || "";
        const bValue = b[sortKey]?.toString().toLowerCase() || "";

        if (aValue < bValue) {
          return order === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
          return order === "asc" ? 1 : -1;
        }
        if (aValue == bValue) {
          // console.log("zxcxzc", "sortedList", aValue == bValue, aValue, bValue);
          return order === "asc" ? 1 : -1;
        }
        return 0;
      });
      // console.log(sortedList, "sortedList");
      setFilteredData(sortedList);
    } else if (name === "stList") {
      let order =
        sortOrder === "asc" ? "desc" : sortOrder === "desc" ? "asc" : "desc";
      setSortOrder(order);
      const sortedLists = studResponse.map((item) => {
        const sortedStudentList = [...item.student_list].sort((a, b) => {
          const aValue = a[sortKey]?.toString().toLowerCase() || "";
          const bValue = b[sortKey]?.toString().toLowerCase() || "";

          if (aValue < bValue) {
            return order === "asc" ? -1 : 1;
          }
          if (aValue > bValue) {
            return order === "asc" ? 1 : -1;
          }
          if (aValue == bValue) {
            return order === "asc" ? 1 : -1;
          }
          return 0;
        });

        return { ...item, student_list: sortedStudentList };
      });
      setStudResponse(sortedLists);
    } else if (name === "atenList") {
      let order = sortOrder === "asc" ? "desc" : "asc";
      setSortOrder(order);
      let sortedList = updateListData.sort((a, b) => {
        if (a[sortKey] < b[sortKey]) {
          return order === "asc" ? -1 : 1;
        }
        if (a[sortKey] > b[sortKey]) {
          return order === "asc" ? 1 : -1;
        }
        if (a[sortKey] == b[sortKey]) {
          // console.log("zxcxzc", "sortedList", aValue == bValue, aValue, bValue);
          return order === "asc" ? 1 : -1;
        }
        return 0;
      });
      setUpdateListData(sortedList);
    }
    // setSortColumn(sortKey);
  };
  // handle filter box open

  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        status: !prevState.status,
        method_of_test: false,
      }));
    } else if (boxName === "evaluateStatus") {
      setIsOpen((prevState) => ({
        evaluateStatus: !prevState.evaluateStatus,
      }));
      setEvaluateStatus(
        updateChipData.filter((ui) => ui.type === "evaluateStatus")
      );
    } else if (boxName === "assignStatus") {
      setIsOpen((prevState) => ({
        assignStatus: !prevState.assignStatus,
      }));
      setAssignStatus(
        updateChipData.filter((ui) => ui.type === "assignStatus")
      );
    } else if (boxName === "dueDate") {
      setIsOpen((prevState) => ({
        dueDate: !prevState.dueDate,
      }));
      const dateRangeData = updateChipDatas.find(
        (ui) => ui.type === "dayRange" || ui.type === "dateRange"
      );

      if (dateRangeData) {
        let bb = "";
        let sb = "";
        if (dateRangeData.name === "Last Week") {
          bb = "Lweek";
          sb = dateRangeData.type;
        } else if (dateRangeData.name === "This Week") {
          bb = "Tweek";
          sb = dateRangeData.type;
        } else if (dateRangeData.name === "This month") {
          bb = "Tmonth";
          sb = dateRangeData.type;
        } else if (dateRangeData.name === "Last month") {
          bb = "Lmonth";
          sb = dateRangeData.type;
        } else {
          bb = dateRangeData.name;
          sb = dateRangeData.type;
        }
        setAppData({
          FDate: dateRangeData.fdate,
          TDate: dateRangeData.edate,
          Days: bb, // Assuming Days might be calculated or set elsewhere
          name: sb,
        });
      }
      setAppOn(
        updateChipDatas.filter(
          (ui) => ui.type === "dateRange" || ui.type === "dayRange"
        )
      );
    } else if (boxName === "assignedDate") {
      setIsOpen((prevState) => ({
        assignedDate: !prevState.assignedDate,
        method_of_test: false,
        status: false,
      }));

      const dateRangeData = updateChipData.find((ui) => ui.type === "dayRange");
      if (dateRangeData) {
        setAppData({
          FDate: dateRangeData.fdate,
          TDate: dateRangeData.edate,
          Days: dateRangeData.name, // Assuming Days might be calculated or set elsewhere
          name: "",
        });
      }
      setAppOn(updateChipData.filter((ui) => ui.type === "dateRange"));
    }
  };
  const handleFilter1 = (e, boxName) => {
    if (boxName === "batch_name") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        batch_name: !prevState.batch_name, // Toggle the value
        section: false,
        medium: false,
        class_mode: false,
        schedule: false,
        location: false,
        status: false,
      }));
      setBatch_name(updateChipData1.filter((ui) => ui.type === "batch_name"));
    } else if (boxName === "section") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        section: !prevState.section, // Toggle the value
        batch_name: false,
        medium: false,
        class_mode: false,
        schedule: false,
        location: false,
        status: false,
      }));
      setSection(updateChipData1.filter((ui) => ui.type === "section"));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        batch_name: false,
        section: false,
        class_mode: false,
        schedule: false,
        location: false,
        status: false,
      }));
      setMedium(updateChipData1.filter((ui) => ui.type === "medium"));
    } else if (boxName === "class_mode") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        class_mode: !prevState.class_mode, // Toggle the value
        batch_name: false,
        section: false,
        medium: false,
        schedule: false,
        location: false,
        status: false,
      }));
      setClassMode(updateChipData1.filter((ui) => ui.type === "class_mode"));
    } else if (boxName === "schedule") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        schedule: !prevState.schedule, // Toggle the value
        batch_name: false,
        section: false,
        medium: false,
        class_mode: false,
        location: false,
        status: false,
      }));
      setSchedule(updateChipData1.filter((ui) => ui.type === "schedule"));
    } else if (boxName === "location") {
      locationsList();
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        location: !prevState.location, // Toggle the value
        batch_name: false,
        section: false,
        medium: false,
        schedule: false,
        status: false,
        class_mode: false,
      }));
      setlocationsId(updateChipData1.filter((ui) => ui.type === "location"));
    } else if (boxName === "status") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        status: !prevState.status, // Toggle the value
        batch_name: false,
        section: false,
        medium: false,
        schedule: false,
        location: false,
        class_mode: false,
      }));
      setStatus_on(updateChipData1.filter((ui) => ui.type === "status"));
    }
  };
  // const handleCheckboxChange = (event, names, typename) => {
  //   const { value, checked, name } = event.target;
  //   if (name === "NotYetEvaluated" || name === "Evaluated") {
  //     if (checked) {
  //       // setStatus([...status, value]);
  //       assignSetStatus([
  //         ...assignStatus,
  //         { id: value, name: name, type: "assignStatus" },
  //       ]);
  //     } else {
  //       evaluateSetStatus(evaluateStatus.filter((item) => item.id !== value));
  //     }
  //   }
  // };

  // due date
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  // descriptive update chipdata
  const [updateChipDatas, setUpdateChipDatas] = useState([]);

  const [updateChipData, setUpdateChipData] = useState([]);
  const [updateChipData1, setUpdateChipData1] = useState([]);

  let filterApplyed = [];
  // due date filter apply
  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);
  useEffect(() => {
    const uniqueBatch = Array.from(
      new Map(updateListData?.map((item) => [item.batch_name, item])).values()
    );

    const uniqueSection = Array.from(
      new Map(updateListData?.map((item) => [item.section, item])).values()
    );
    setBatchList(uniqueBatch);
    setSectionList(uniqueSection);
  }, [updateListData]);
  // call find by id when chipdata updated
  useEffect(() => {
    findById(id);
  }, [updateChipData]);
  function locationsList() {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        if (res.data.status) {
          let branches = res.data.data.map((item) => ({
            id: item.id,
            name: item.name,
            phoneNumber: item.mobile_no,
            address: item.address,
            pincode: item.zipcode,
          }));
          setlocationsId(branches);
        } else {
          setlocationsId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }
  useEffect(() => {
    findById(id);
  }, [updateChipDatas]);
  useEffect(() => {
    filterMedium = medium_on;
  }, [medium_on]);
  useEffect(() => {
    filterBatchName = batch_name;
  }, [batch_name]);
  useEffect(() => {
    loadListdata();
  }, [updateChipData1]);
  useEffect(() => {
    locationsList();
  }, []);
  const [appOn, setAppOn] = useState([]);

  const handleRadioChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => ({ ...prevState, [name]: value }));
      const from = name === "FDate" ? value : appData.FDate;
      const to = name === "TDate" ? value : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: from !== "" ? moment(from).format("YYYY-MM-DD") : "",
          edate: to !== "" ? moment(to).format("YYYY-MM-DD") : "",
          type: "dateRange",
        },
      ]);
    } else if (name === "Days") {
      if (checked) {
        setAppData((prevState) => ({ ...prevState, [name]: value }));
      }
      // else {
      //   setAppOn(appOn.filter((item) => item !== value));
      // }
      if (value === "Today") {
        const today = new Date();
        setAppOn([
          {
            name: value,
            fdate: moment(today.toDateString()).format("YYYY-MM-DD"),
            edate: moment(today.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Yesterday") {
        const today = new Date(); // Get today's date
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        setAppOn([
          {
            name: value,
            fdate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            edate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tweek") {
        const today = new Date(); // Get today's date
        const thisWeekStartDate = moment(today)
          .subtract(0, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const thisWeekEndDate = moment(today)
          .subtract(0, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "This week",
            fdate: moment(thisWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lweek") {
        const today = new Date(); // Get today's date
        const lastWeekStartDate = moment(today)
          .subtract(1, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const lastWeekEndDate = moment(today)
          .subtract(1, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "Last week",
            fdate: moment(lastWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tmonth") {
        const today = new Date(); // Get today's date
        const thisMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        ); // Get start date of this month
        const thisMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        setAppOn([
          {
            name: "This month",
            fdate: moment(thisMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lmonth") {
        const today = new Date();
        const lastMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const lastMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        setAppOn([
          {
            name: "Last month",
            fdate: moment(lastMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      }
    }
  };

  // const handleChangeDate = (date, name) => {
  //   const dateFilter = moment(date).format("YYYY-MM-DD");
  //   if (name === "FDate" || name === "TDate") {
  //     setAppData((prevState) => ({ ...prevState, [name]: dateFilter }));
  //     const from = name === "FDate" ? dateFilter : appData.FDate;
  //     const to = name === "TDate" ? dateFilter : appData.TDate;
  //     const dateRange = `${from} - ${to}`;
  //     setAppOn([
  //       {
  //         name: dateRange,
  //         fdate: moment(from).format("YYYY-MM-DD"),
  //         edate: moment(to).format("YYYY-MM-DD"),
  //         type: "dateRange",
  //       },
  //     ]);
  //   }
  // };
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (!date) {
      return; // Exit if the date is not valid
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name === "FDate" || name === "TDate") {
      // Ensure valid From and To date selection
      const from = name === "FDate" ? dateFilter : appData.FDate;
      const to = name === "TDate" ? dateFilter : appData.TDate;

      if (name === "TDate" && moment(to).isBefore(moment(from))) {
        // Validation error: To Date is earlier than From Date
        setErrors((prev) => ({
          ...prev,
          TDate: "To Date cannot be earlier than From Date.",
        }));
        return;
      }

      if (name === "FDate" && moment(from).isAfter(moment(to)) && to) {
        // Validation error: From Date is later than To Date
        setErrors((prev) => ({
          ...prev,
          FDate: "From Date cannot be later than To Date.",
        }));
        return;
      }

      // Update state with valid date and date range
      setAppData((prevState) => ({ ...prevState, [name]: dateFilter }));
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    }
  };
  const handleCheckboxChange = (event) => {
    const { value, checked, name } = event.target;
    if (name === "NotYetAssigned" || name === "Assigned") {
      if (checked) {
        setAssignStatus([
          ...assignStatus,
          { id: value, name: name, type: "assignStatus" },
        ]);
      } else {
        setAssignStatus(assignStatus.filter((item) => item.id !== value));
      }
    }
    if (name === "NotYetEvaluated" || name === "Evaluated") {
      if (checked) {
        // setStatus([...status, value]);
        setEvaluateStatus([
          ...evaluateStatus,
          { id: value, name: name, type: "evaluateStatus" },
        ]);
      } else {
        setEvaluateStatus(evaluateStatus.filter((item) => item.id !== value));
      }
    }
  };
  const handleCheckboxChange1 = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "batch_name") {
      if (checked) {
        setBatch_name([
          ...batch_name,
          { id: value, name: name, type: "batch_name" },
        ]);
      } else {
        setBatch_name(batch_name.filter((item) => item.id !== value));
      }
    } else if (typename === "section") {
      if (checked) {
        setSection([{ id: value, name: name, type: "section" }]);
      } else {
        setSection(section.filter((item) => item.id !== value));
      }
    } else if (typename === "schedule") {
      if (checked) {
        setSchedule([{ id: value, name: name, type: "schedule" }]);
      } else {
        setSchedule(schedule.filter((item) => item.id !== value));
      }
    } else if (typename === "class_mode") {
      if (checked) {
        setClassMode([{ id: value, name: name, type: "class_mode" }]);
      } else {
        setClassMode(classMode.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([{ id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (typename === "location") {
      if (checked) {
        setLocations([
          ...locations,
          { id: value, name: name, type: "location" },
        ]);
      } else {
        setLocations(locations.filter((item) => item.id !== value));
      }
    } else if (typename === "status") {
      if (checked) {
        setStatus_on([{ id: value, name: name, type: "status" }]);
      } else {
        setStatus_on(status_on.filter((item) => item.id !== value));
      }
    }
  };
  function loadChipdata() {
    let tempArr = [];
    // setUpdateChipData(status);
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });

    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });
    filterAssignStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterEvaluateStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterBatchName.map((obj) => {
      tempArr.push(obj);
    });

    setUpdateChipData(tempArr);
  }
  function loadChipdata1() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterBatchName.map((obj) => {
      tempArr.push(obj);
    });

    filterSection.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    filterClassMode.map((obj) => {
      tempArr.push(obj);
    });
    filterSchedule.map((obj) => {
      tempArr.push(obj);
    });
    filterLocation.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus1.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData1(tempArr);
  }
  function loadChipdatas() {
    let tempArr = [];

    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });

    setUpdateChipDatas(tempArr);
  }
  const [errors, setErrors] = useState({ FDate: "", TDate: "" });

  const handleApplyFilter = (name) => {
    updateStateData();

    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "evaluateStatus") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        evaluateStatus: false,
      });
    } else if (name === "assignStatus") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        assignStatus: false,
      });
    } else if (name === "assignedDate") {
      let validationErrors = {};

      if (!appData.FDate) {
        validationErrors.FDate = "Please select a from date";
      }

      if (!appData.TDate) {
        validationErrors.TDate = "Please select a to date";
      }

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
      setErrors({});
      loadChipdata();
      setIsOpen({
        ...isOpen,
        assignedDate: false,
      });
    }
  };

  const handleApplyFilters = (name) => {
    updateStateDatas();
    if (name === "dueDate") {
      let validationErrors = {};

      if (!appData.FDate) {
        validationErrors.FDate = "Please select a from date";
      }

      if (!appData.TDate) {
        validationErrors.TDate = "Please select a to date";
      }

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
      setErrors({});
      loadChipdatas();
      setIsOpen({
        ...isOpen,
        dueDate: false,
      });
    }
  };
  const handleApplyFilter1 = (name, event) => {
    updateStateData1();
    if (name === "batch_name") {
      loadChipdata1();
      setIsOpen({
        ...isOpen,
        batch_name: false,
      });
    } else if (name === "section") {
      loadChipdata1();
      setIsOpen({
        ...isOpen,
        section: false,
      });
    } else if (name === "medium") {
      loadChipdata1();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "class_mode") {
      loadChipdata1();
      setIsOpen({
        ...isOpen,
        class_mode: false,
      });
    } else if (name === "schedule") {
      loadChipdata1();
      setIsOpen({
        ...isOpen,
        schedule: false,
      });
    } else if (name === "location") {
      loadChipdata1();
      setIsOpen({
        ...isOpen,
        location: false,
      });
    } else if (name === "status") {
      loadChipdata1();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    }
  };
  function updateStateData() {
    filterStatus = status;
    filterAssignStatus = assignStatus;
    filterEvaluateStatus = evaluateStatus;

    // class Attendance
  }
  function updateStateDatas() {
    filterApplyed = appOn;
  }
  function updateStateData1() {
    filterBatchName = batch_name;
    filterSection = section;
    filterClassMode = classMode;
    filterSchedule = schedule;
    filterLocation = locations;
    filterMedium = medium_on;
    filterStatus1 = status_on;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  // close the popu when mouse click outside

  const handleClickOutside = (event) => {
    const isChipData = event.target.closest(".paperil_global");
    const isCheckbox = event.target.closest('input[type="checkbox"]');
    // Check if the click target is the "Apply Filter" button
    const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
    if (
      filterRef.current &&
      !filterRef.current.contains(event.target) &&
      !isChipData
    ) {
      if (!isOpen.dueDate && appOn.length === 0) {
        setIsOpen((prevState) => ({ ...prevState, dueDate: false }));
      }
    }
    if (
      filterRefAssign.current &&
      !filterRefAssign.current.contains(event.target) &&
      !isCheckbox &&
      !isApplyFilterButton &&
      !isChipData
    ) {
      if (!isOpen.assignStatus) {
        setIsOpen((prevState) => ({ ...prevState, assignStatus: false }));
      } else if (!isOpen.assignStatus) {
        // console.log("______hello world2");

        setIsOpen((prevState) => ({ ...prevState, assignStatus: false }));
      }
    }
    if (
      filterRefEvaluate.current &&
      !filterRefEvaluate.current.contains(event.target) &&
      !isCheckbox &&
      !isApplyFilterButton &&
      !isChipData
    ) {
      if (!isOpen.evaluateStatus) {
        setIsOpen((prevState) => ({ ...prevState, evaluateStatus: false }));
      } else if (!isOpen.evaluateStatus) {
        // console.log("______hello world2");

        setIsOpen((prevState) => ({ ...prevState, evaluateStatus: false }));
      }
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside1 = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterRef_batch_name.current &&
        !filterRef_batch_name.current.contains(event.target)
      ) {
        {
          const hasBatch = updateChipData1.some(
            (chipItem) => chipItem.type === "batch_name"
          );
          if (hasBatch) {
            const updatedAuthor = updateChipData1.filter(
              (chipItem) => chipItem.type === "batch_name"
            );
            setBatch_name(updatedAuthor);
          } else {
            setBatch_name([]);
          }
          setIsOpen((prev) => ({ ...prev, batch_name: false }));
        }
      }
      if (
        filterRef_section.current &&
        !filterRef_section.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData1.some(
            (chipItem) => chipItem.type === "section"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData1.filter(
              (chipItem) => chipItem.type === "section"
            );
            setSection(updatedCategory);
          } else {
            setSection([]);
          }
          setIsOpen((prev) => ({ ...prev, section: false }));
        }
      }
      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData1.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData1.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }
      if (
        filterRef_class_mode.current &&
        !filterRef_class_mode.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData1.some(
            (chipItem) => chipItem.type === "class_mode"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData1.filter(
              (chipItem) => chipItem.type === "class_mode"
            );
            setClassMode(updatedCategory);
          } else {
            setClassMode([]);
          }
          setIsOpen((prev) => ({ ...prev, class_mode: false }));
        }
      }
      if (
        filterRef_schedule.current &&
        !filterRef_schedule.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData1.some(
            (chipItem) => chipItem.type === "schedule"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData1.filter(
              (chipItem) => chipItem.type === "schedule"
            );
            setSchedule(updatedCategory);
          } else {
            setSchedule([]);
          }
          setIsOpen((prev) => ({ ...prev, schedule: false }));
        }
      }
      if (
        filterRef_location.current &&
        !filterRef_location.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData1.some(
            (chipItem) => chipItem.type === "location"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData1.filter(
              (chipItem) => chipItem.type === "location"
            );
            setLocations(updatedCategory);
          } else {
            setLocations([]);
          }
          setIsOpen((prev) => ({ ...prev, location: false }));
        }
      }

      if (
        filterRef_status.current &&
        !filterRef_status.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData1.some(
            (chipItem) => chipItem.type === "status"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData1.filter(
              (chipItem) => chipItem.type === "status"
            );
            setStatus_on(updatedCategory);
          } else {
            setStatus_on([]);
          }
          setIsOpen((prev) => ({ ...prev, status: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside1);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside1);
    };
  }, [
    updateChipData1,
    batch_name,
    section,
    medium,
    classMode,
    schedule,
    locations,
    status_on,
  ]);

  let filterStatus1 = [];
  let filterStatus = [];
  let filterAssignStatus = [];
  let filterEvaluateStatus = [];

  const handleClear = (name) => {
    setErrors({});

    if (name === "status") {
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "assignStatus") {
      filterAssignStatus = [];
      setAssignStatus([]);
      // setIsOpen({ ...isOpen, assignStatus: false });
    } else if (name === "evaluateStatus") {
      filterEvaluateStatus = [];
      setEvaluateStatus([]);
      // setIsOpen({
      //   ...isOpen,
      //   evaluateStatus: false,
      // });
    }
  };
  const handleClears = (name) => {
    if (name === "dueDate") {
      // setAppOn([]);
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
    }
  };
  const handleClear1 = (name) => {
    const updatedChips = updateChipData1.filter((item) => item.type !== name);
    setUpdateChipData1(updatedChips);
    setIsOpen({
      batch_name: false,
      section: false,
      medium: false,
      class_mode: false,
      schedule: false,
      location: false,
      status: false,
    });
    if (name === "batch_name") {
      setBatch_name([]);
      filterBatchName = [];
    } else if (name === "section") {
      setSection([]);
      filterSection = [];
    } else if (name === "medium") {
      setMedium_on([]);
      filterMedium = [];
    } else if (name === "class_mode") {
      setClassMode([]);
      filterClassMode = [];
    } else if (name === "schedule") {
      setSchedule([]);
      filterSchedule = [];
    } else if (name === "location") {
      setLocations([]);
      filterLocation = [];
    } else if (name === "status") {
      setStatus_on([]);
      filterStatus = [];
    }
  };

  //pagination
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    findById(id);
  };
  const handlePrev = (newPage) => {
    if (newPage >= 1) {
      setCurrentPage(newPage);
    }
  };
  const handleNext = (newPage) => {
    if (newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const handlePageCount1 = (e) => {
    setRowsPerPage1(Number(e.target.value));
    setCurrentPage1(1);
    setUpdateListData([]);
    loadListdata();
  };
  // total table data  with pages
  const handlePrev1 = (newPage) => {
    if (newPage >= 1) {
      setCurrentPage1(newPage);
    }
  };

  const handleNext1 = (newPage) => {
    if (newPage <= totalPages1) {
      setCurrentPage1(newPage);
    }
  };

  const handlePageCounts = (e) => {
    setRowsPerPages(Number(e.target.value));
    setCurrentPages(1);
    findById(id);
  };

  // total table data  with pages
  const handlePrevs = (newPage) => {
    if (newPage >= 1) {
      setCurrentPages(newPage);
    }
  };

  const handleNexts = (newPage) => {
    if (newPage <= totalPages_de) {
      setCurrentPages(newPage);
    }
  };

  const handleShow = (doE) => {
    if (doE === 0) {
      setOpen(true);
    } else {
      setOpen_doubleeva(true);
    }
  };
  const handleModelClose = () => {
    setOpen(false);
    setError({
      ...error,
      evaluvatorName: "",
      eventDate1: "",
    });
  };
  const handleModelClose_des = () => {
    setOpen_doubleeva(false);
    if (statusRetained) {
      setEvaluatorList2([]);
      setDropdownValue2(null);
      setList({
        ...list,
        eventDate2: "",
      });
    } else if (statusRetained1) {
      setEvaluatorList1([]);
      setDropdownValue1(null);
      setList({
        ...list,
        eventDate: "",
      });
    } else {
      setEvaluatorList2([]);
      setDropdownValue2(null);
      setEvaluatorList1([]);
      setDropdownValue1(null);
      setList({
        ...list,
        eventDate: "",
        eventDate2: "",
      });
    }
    setError({
      ...error,
      evaluatorName1: "",
      evaluatorName2: "",
      eventDate: "",
      eventDate2: "",
    });
  };

  const [listErrors, setListErrors] = useState({});

  const evaluatorDueDate =
    evaluatorList?.length > 0 &&
    evaluatorList?.map((item) => {
      return item.due_date;
    });
  const evaluatorDueDate1 =
    evaluatorList1?.length > 0 &&
    evaluatorList1?.map((item) => {
      return item.due_date;
    });
  const evaluatorDueDate2 =
    evaluatorList2?.length > 0 &&
    evaluatorList2?.map((item) => {
      return item.due_date;
    });
  const evaluatorCount =
    evaluatorList?.length > 0 &&
    evaluatorList?.map((item) => {
      return item.evaluator_count;
    });

  const staffId =
    evaluatorList?.length > 0 &&
    evaluatorList?.map((item) => {
      return item.staff_id;
    });
  const staffId1 =
    evaluatorList1?.length > 0 &&
    evaluatorList1?.map((item) => {
      return item.staff_id;
    });
  const staffId2 =
    evaluatorList2?.length > 0 &&
    evaluatorList2?.map((item) => {
      return item.staff_id;
    });

  const staff_find_id1 = dropdownValue1?.value;

  const staff_find_id2 = dropdownValue2?.value;

  const validateERRORDEFields = (
    DVALUE,
    DVALUE1,
    DVALUE2,
    DUEDATE1,
    DUEDATE2,
    DUEDATE,
    DsRetained,
    DsRetained1
  ) => {
    const errors = {};

    if (fdata.double_evaluation == 0 && DVALUE === null) {
      errors.evaluatorName = "Please select evaluator name";
    }
    if (fdata.double_evaluation == 0 && DUEDATE1 == "") {
      errors.eventDate1 = "Please select your due date";
    }

    if (fdata.double_evaluation == 1 && DVALUE1 === null && DVALUE2 === null) {
      errors.evaluatorName1 = "Please select an evaluator name";
    }
    if (
      fdata.double_evaluation == 1 &&
      DVALUE1 !== null &&
      DVALUE2 === null &&
      DsRetained === true
    ) {
      errors.evaluatorName2 = "Please select  an evaluator name";
    }
    if (fdata.double_evaluation == 1 && DVALUE1 === null && DVALUE2 === null) {
      errors.evaluatorName2 = "Please select an evaluator name";
    }
    if (
      fdata.double_evaluation == 1 &&
      DVALUE1 === null &&
      DVALUE2 !== null &&
      DsRetained1 === true
    ) {
      errors.evaluatorName1 = "Please select evaluator";
    }
    if (fdata.double_evaluation === 1) {
      if (dropdownValue1 && !DUEDATE) {
        errors.eventDate = "Please select due date";
      }

      if (dropdownValue2 && !DUEDATE2) {
        errors.eventDate2 = "Please select due date";
      }
    }
    // if (
    //   fdata.double_evaluation == 1 &&
    //   DVALUE2 !== null &&
    //   DVALUE1 === null &&
    //   DsRetained1 === true &&
    //   DUEDATE == ""
    // ) {
    //   errors.eventDate = "Please select due date";
    // }
    // if (
    //   fdata.double_evaluation == 1 &&
    //   DVALUE2 === null &&
    //   DVALUE1 === null &&
    //   DUEDATE == ""
    // ) {
    //   errors.eventDate = "Please select due date";
    // }
    // if (
    //   fdata.double_evaluation == 1 &&
    //   DVALUE2 === null &&
    //   DVALUE1 !== null &&
    //   DsRetained === true &&
    //   DUEDATE2 == ""
    // ) {
    //   errors.eventDate2 = "Please select due date";
    // }
    // if (
    //   fdata.double_evaluation == 1 &&
    //   DVALUE2 === null &&
    //   DVALUE1 === null &&
    //   DUEDATE2 == ""
    // ) {
    //   errors.eventDate2 = "Please select due date";
    // }
    return errors;
  };

  const handleClose = () => {
    const errors = validateERRORDEFields(
      dropdownValue,
      dropdownValue1,
      dropdownValue2,
      list.eventDate1,
      list.eventDate2,
      list.eventDate,
      statusRetained,
      statusRetained1
    );

    if (Object.keys(errors).length === 0) {
      const bb = selectedStudents.map((io) => ({
        user_id: io.user_id,
        stud_list_id: io.stud_id,
      }));
      const evaluator_date = evaluatorDueDate[0];
      const evaluator_date1 = evaluatorDueDate1[0];
      const evaluator_date2 = evaluatorDueDate2[0];

      let assignEvaluator = [];

      if (resData?.double_evaluation == 0) {
        assignEvaluator = {
          double_evaluation: fdata?.double_evaluation,
          staff: [
            {
              staff_id: staffId[0],
              // staff_id: staffId,
              due_date: evaluator_date
                ? moment(evaluator_date).format("YYYY-MM-DD")
                : list.eventDate1,
              event_id: fdata.event_id,
              batch_id: selectedStudents[0]?.batch_id,
              evaluator_count: 1, // evaluvator count
              created_by: userid,
              created_date: moment().format("YYYY-MM-DD "), // Format as ISO date string
              assign_count: selectedStudents.length, // Additional field

              student_details: bb,
            },
          ],
        };
      } else {
        let assignEvaluator_vaue = {};
        if (
          dropdownValue1 != null &&
          dropdownValue2 != null &&
          Object.keys(dropdownValue1).length > 0 &&
          Object.keys(dropdownValue2).length > 0
        ) {
          assignEvaluator_vaue = {
            double_evaluation: fdata?.double_evaluation,
            staff: [
              {
                staff_id: staffId1.length > 0 ? staffId1[0] : staff_find_id1,
                due_date: evaluator_date1
                  ? moment(evaluator_date1).format("YYYY-MM-DD ")
                  : list.eventDate
                    ? moment(list.eventDate).format("YYYY-MM-DD ")
                    : list.eventDate,
                event_id: fdata.event_id,
                batch_id: selectedStudents[0]?.batch_id,
                // evaluator_count: studResponse?.double_evaluation === 0 ? 1 : 2,
                evaluator_count: 1,

                created_by: userid,
                created_date: moment().format("YYYY-MM-DD "),
                assign_count: selectedStudents.length,

                student_details: bb,
              },

              {
                staff_id: staffId2.length > 0 ? staffId2[0] : staff_find_id2,
                due_date: evaluator_date1
                  ? moment(evaluator_date1).format("YYYY-MM-DD ")
                  : list.eventDate2
                    ? moment(list.eventDate2).format("YYYY-MM-DD ")
                    : list.eventDate2,
                event_id: fdata.event_id,
                batch_id: selectedStudents[0]?.batch_id,
                // evaluator_count: studResponse?.double_evaluation === 0 ? 1 : 2,
                evaluator_count: 2,
                created_by: userid,
                created_date: moment().format("YYYY-MM-DD HH:mm:ss"), // Format as ISO date string
                assign_count: selectedStudents.length, // Additional field
                student_details: bb,
              },
            ],
          };
        } else {
          assignEvaluator_vaue = {
            double_evaluation: fdata?.double_evaluation,
            staff: [
              {
                staff_id:
                  staffId1.length > 0
                    ? staffId1[0]
                    : staffId2.length > 0
                      ? staffId2[0]
                      : staff_find_id,
                due_date:
                  staffId1.length > 0
                    ? evaluator_date1
                      ? moment(evaluator_date1).format("YYYY-MM-DD")
                      : list.eventDate
                        ? moment(list.eventDate).format("YYYY-MM-DD")
                        : list.eventDate
                    : evaluator_date2
                      ? moment(evaluator_date2).format("YYYY-MM-DD")
                      : list.eventDate2
                        ? moment(list.eventDate2).format("YYYY-MM-DD")
                        : list.eventDate2,
                event_id: fdata.event_id,
                batch_id: selectedStudents[0]?.batch_id,
                // evaluator_count: studResponse?.double_evaluation === 0 ? 1 : 2,
                evaluator_count:
                  dropdownValue2 !== null &&
                    Object.keys(dropdownValue2).length > 0
                    ? 2
                    : 1,
                created_by: userid,
                created_date: moment().format("YYYY-MM-DD HH:mm:ss"),
                assign_count: selectedStudents.length,

                student_details: bb,
              },
            ],
          };
        }

        assignEvaluator = assignEvaluator_vaue;
      }
      AxiosInstance.post(
        "api/test/descriptive/evaluator_assign",
        assignEvaluator
      )
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            setSelectedStudents([]);
            setDropdownValue(null);
            setDropdownValue1(null);
            setDropdownValue2(null);
            setEvaluatorList("");
            setEvaluatorList1(null);
            setEvaluatorList2(null);
            setStatusRetained(false);
            setStatusRetained1(false);
            setList({
              ...list,
              eventDate: "",
              eventDate1: "",
            });
            setFlagReload(!flagReload);
          } else {
            toast.error(res.data.message);
          }
          setOpen(false);
          setOpen_doubleeva(false);
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };
  const handleModalClose = () => {
    setOpens(false);
  };
  const handleClose1 = () => {
    try {
      {
        // If no id is provided, add the new data
        const createAnnouncementData = {
          id: id,
          created_by: userid,
          path: fdata.AttendancesheetPath,
          original_filepath: fdata.answer_sheet_original_path,
          recording_url: fdata.iframe,
        };
        AxiosInstance.post(
          `api/test/upload/attendancesheet`,
          createAnnouncementData
        )
          .then((res) => {
            // console.log(res);
            if (res.data.status) {
              toast.success(res.data.message);
              setOpens(false);
              loadListdata();

              // fetchEventData();
            } else {
              toast.error(res.data.message);
              setOpens(false);
              loadListdata();
            }
          })
          .catch((error) => {
            setOpens(false);
            return error;
          });
      }
    } catch (error) {
      console.log(error);
      setOpens(false);
    }
  };
  const [selectedEvaluator, setSelectedEvaluator] = useState(null);
  const [selectedDueDate, setSelectedDueDate] = useState(null);
  const [dropdownValue, setDropdownValue] = useState(null);

  const [error, setError] = useState({
    evaluatorName: "",
    eventDate: "",
    eventDate2: "",
    eventDate1: "",
    evaluatorName1: "",
    evaluatorName2: "",
  });

  // Handle evaluator selection

  // new code
  const handleSelectChange = async (selectedOption, dropdownName) => {
    if (selectedOption) {
      let selectedEvaluatorId = selectedOption.value;
      // Retain the selected value for the dropdown that triggered the error
      if (dropdownName === "evaluatorName") {
        setDropdownValue(selectedOption);
        setEvaluatorList([]);
        setError({
          ...error,
          evaluatorName: "",
        });
        UpdateEva(selectedEvaluatorId, id, dropdownName);
      } else if (dropdownName === "evaluatorName1") {
        if (dropdownValue2?.value == selectedEvaluatorId) {
          // setDropdownValue1();
          // setEvaluatorList1([]);
          setError({
            ...error,
            ["evaluatorName1"]: "Please select another evaluator",
            ["evaluatorName2"]: "",
          });
        } else {
          setDropdownValue1(selectedOption);
          setEvaluatorList1([]);
          setError({
            ...error,
            ["evaluatorName1"]: "",
            ["evaluatorName2"]: "",
            ["eventDate"]: "",
          });
          UpdateEva(selectedEvaluatorId, id, dropdownName);
        }
      } else if (dropdownName === "evaluatorName2") {
        if (dropdownValue1?.value == selectedEvaluatorId) {
          setError({
            ...error,
            evaluatorName2: "Please select another evaluator",
            evaluatorName1: "",
          });
        } else {
          setDropdownValue2(selectedOption);
          setEvaluatorList2([]);
          setError({
            ...error,
            evaluatorName2: "",
            evaluatorName1: "",
            eventDate2: "",
          });
          UpdateEva(selectedEvaluatorId, id, dropdownName);
        }
      }
    } else {
      if (dropdownName === "evaluatorName") {
        setDropdownValue(null);
        setEvaluatorList([]);
      } else if (dropdownName === "evaluatorName1") {
        setDropdownValue1(null);
        setEvaluatorList1([]);
        setStaffMem([]);
      } else if (dropdownName === "evaluatorName2") {
        setDropdownValue2(null);
        setEvaluatorList2([]);
        setStaffMem([]);
      }
    }
  };

  const UpdateEva = async (selectedEvaluatorIds, ids, dropdownNames) => {
    const staff_id = { staff_id: selectedEvaluatorIds, event_id: ids };
    try {
      const res = await AxiosInstance.post("api/staff/allEvaluator", staff_id);
      if (res.data.status === true) {
        const staffMem = res.data.data.map((item) => ({
          staff_id: item.staff_id,
          total_assigned_students: item.total_assigned_students,
        }));
        setStaffMem(staffMem);

        if (dropdownNames === "evaluatorName") {
          setList((prevState) => ({
            ...prevState,
            eventDate1:
              res.data.data.length > 0 ? res.data.data[0].due_date : "",
          }));
          setEvaluatorList(staffMem);
        } else if (dropdownNames === "evaluatorName1") {
          setEvaluatorList1(staffMem);
          setList((prevState) => ({
            ...prevState,
            eventDate:
              res.data.data.length > 0 ? res.data.data[0].due_date : "",
          }));
        } else if (dropdownNames === "evaluatorName2") {
          setEvaluatorList2(staffMem);
          setList((prevState) => ({
            ...prevState,
            eventDate2:
              res.data.data.length > 0 ? res.data.data[0].due_date : "",
          }));
        }
      } else {
        const fallbackData = [
          {
            staff_id: selectedEvaluatorIds,
            total_assigned_students: null,
            due_date: null,
            evaluator_count: null,
          },
        ];
        if (dropdownNames === "evaluatorName") setEvaluatorList(fallbackData);
        if (dropdownNames === "evaluatorName1") setEvaluatorList1(fallbackData);
        if (dropdownNames === "evaluatorName2") setEvaluatorList2(fallbackData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const customStyles = {
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
    }),
  };
  const [supervisorList, setSupervisorList] = useState([]);

  useEffect(() => {
    apiGetAllSupervisors()
      .then((res) => {
        if (res.status) {
          setSupervisorList(res.data);
        } else {
          setSupervisorList([]);
        }
      })
      .catch((err) => {
        console.error("all-supervisors list", err);
        // setIsPageLoading(false);
      });
  }, []);
  const groupedSupervisors = supervisorList.reduce((acc, supervisor) => {
    const type = supervisor.staff_type;
    if (!acc[type]) acc[type] = [];
    acc[type].push(supervisor);
    return acc;
  }, {});
  const groupedOptions = Object.keys(groupedSupervisors).map((type) => ({
    label: type === "0" ? "Faculty" : type === "1" ? "Staff" : "Panel Member",
    options: groupedSupervisors[type].map((sup) => ({
      value: sup.id,
      label: sup.full_name,
    })),
  }));
  // const [usersId, setUsersId] = useState("");
  // const [studentListId, setStudentListId]=useState("");

  const studentListId = selectedStudents?.map((item) => {
    return item.stud_id;
  });

  // Handle date selection
  const handleDateChange = (date) => {
    setSelectedDueDate(date);
  };
  const stud_list_id = studResponse?.student_list?.map((item) => {
    return item.student_list?.map((studid) => {
      return studid.stud_list_id;
    });
  });

  const handleTableCheckboxChange = (
    e,
    userId,
    studId,
    staff_name,
    batch_ids,
    DOEV
  ) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedStudents((prevState) => [
        ...prevState,
        { user_id: userId, stud_id: studId, batch_id: batch_ids },
      ]);
      if (DOEV === 1) {
        // Assuming `staff_name` is an array and we're using `forEach` to iterate over each item
        if (staff_name && staff_name.length > 0) {
          staff_name.forEach((op) => {
            if (op.evaluator === 1) {
              const bb = {
                value: op.id,
                label: op.staff_name,
              };
              setList((prevState) => ({
                ...prevState,
                eventDate: op.due_date,
                eventDate2: "",
              }));
              setDropdownValue1(bb);
              setDropdownValue2(null);

              setEvaluatorList2([]);
              UpdateEva(op.id, id, "evaluatorName1");
              setStatusRetained(true);
              setStatusRetained1(false);
            } else {
              const bsb = {
                value: op.id,
                label: op.staff_name,
              };
              setList((prevState) => ({
                ...prevState,
                eventDate2: op.due_date,
                eventDate: "",
              }));
              setEvaluatorList1([]);
              setDropdownValue2(bsb);
              setDropdownValue1(null);
              setStatusRetained(false);
              UpdateEva(op.id, id, "evaluatorName2");
              setStatusRetained1(true);
            }
          });
        } else {
          setDropdownValue1(null);
          setDropdownValue2(null);
          setStatusRetained(false);
          setStatusRetained1(false);
          setEvaluatorList1([]);
          setEvaluatorList2([]);
          setList((prevState) => ({
            ...prevState,
            eventDate: "",
            eventDate2: "",
          }));
        }
      } else {
      }
    } else {
      setSelectedStudents((prevState) =>
        prevState.filter((isd) => isd.user_id !== userId)
      );
    }
  };

  const handleTableCheckboxChangeAll = (e, acTab, datas) => {
    // Ensure datas and student_list are defined
    const dat = datas;
    if (!dat) {
      console.error("student_list is not available or undefined");
      return; // Exit the function early if student_list is not available
    }
    const isChecked = e.target.checked;
    if (isChecked) {
      const newSelectedStudents = dat
        ?.filter((df) => df.assign_status === 0) // Only students with assign_status === 0
        .map((ui) => ({
          user_id: ui.user_id,
          stud_id: ui.stud_list_id,
          batch_id: ui.batch_id,
        }));

      setSelectedStudents(newSelectedStudents); // Update the selected students state
    } else {
      setSelectedStudents([]); // Clear selected students when unchecked
    }
  };
  const txtAdMDob = useRef(null);
  const txtAdMDob_evone = useRef(null);
  const txtAdMDob_evtwo = useRef(null);

  const DobCovertAge = (dob) => {
    var ageInYears = moment().diff(dob, "years", false);
    return ageInYears;
  };
  const handleChangeDates = (date, name) => {
    const dateDOB = moment(date).format("YYYY-MM-DD");
    setList({
      ...list,
      [name]: dateDOB,
    });
    setError({
      ...error,
      eventDate: "",
      eventDate1: "",
      eventDate2: "",
      due_dates1: "",
    });
  };
  const handleMonthChange = (month, dname) => {
    // console.log(month, "month");
    if (dname === "DOB") {
      if (list.DOB !== null && list.DOB !== "") {
        const currentDate = new Date(list.DOB);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        const age = DobCovertAge(currentDate_moment);
        if (age >= 18 && age <= 60) {
          setList({
            ...list,
            ["DOB"]: currentDate_moment,
            ["age"]: age,
          });
          setListErrors({
            ...listErrors,
            ["DOB"]: "",
            ["age"]: "",
          });
        } else {
          const err =
            "Please enter a valid date of birth. age should be between 18 and 60 years";
          setList({
            ...list,
            age: "",
          });
          setListErrors({
            ...listErrors,
            DOB: err,
          });
        }
      }
    } else if (dname === "JoinGovt") {
      if (
        list.JoinGovt !== null &&
        list.JoinGovt !== "" &&
        list.JoinGovt !== undefined
      ) {
        const currentDate = new Date(list.JoinGovt);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      }
    }
  };
  const handleYearChange = (year, dname) => {
    if (dname === "DOB") {
      if (list.DOB !== null && list.DOB !== "") {
        const currentDate = new Date(list.DOB);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        const age = DobCovertAge(currentDate_moment);
        if (age >= 18 && age <= 60) {
          setList({
            ...list,
            ["DOB"]: currentDate_moment,
            ["age"]: age,
          });
          setListErrors({
            ...listErrors,
            ["DOB"]: "",
            ["age"]: "",
          });
        } else {
          const err =
            "Please enter a valid date of birth. age should be between 18 and 60 years";
          setList({
            ...list,
            age: "",
          });
          setListErrors({
            ...listErrors,
            DOB: err,
          });
        }
      }
    } else if (dname === "JoinGovt") {
      if (
        list.JoinGovt !== null &&
        list.JoinGovt !== "" &&
        list.JoinGovt !== undefined
      ) {
        const currentDate = new Date(list.JoinGovt);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      }
    }
  };

  const handleEvaluvatorReadView = (
    evaluvatorName,
    eventIDHJ,
    StaffUID,
    Astatus,
    EvalCount,
    User_Staff
  ) => {
    navigate("/ViewEvaluator", {
      state: {
        EVNAME: evaluvatorName,
        EVID: eventIDHJ,
        STAFFID: StaffUID,
        ADMORST: Astatus,
        BID: fdata.batch_id,
        EVCOUNT: EvalCount,
      },
    });
  };

  // const handleSHIflagReload = () => {
  //   console.log("--- is calling");
  //   setShowPublicResults(false);
  //   setShowMo(false);
  // };

  const USER_ID = selectedStudents.map((id) => {
    return id.user_id;
  });
  const handleStudentView = (userIDKIO, EVCOUNT) => {
    navigate("/AdminViewStudent/0", {
      state: {
        EVENTID: fdata.event_id,
        USER_ID: userIDKIO,
        EVCOUNTS: EVCOUNT,
      },
    });
  };
  const start1 = (currentPage1 - 1) * rowsPerPage1;
  const end1 = start1 + rowsPerPage1;
  const currentData1 = updateListData?.slice(start1, end1);
  // for descriptive
  const start = (currentPages - 1) * rowsPerPages;
  const end = start + rowsPerPages;
  const currentDatas = filteredData?.slice(start, end);
  const handleDownloadSyllabus = (path) => {
    window.open(`${ImageUrlPrefix}/${path}`);
  };

  // Filter data: matching batch_id comes first, then non-matching batch_id
  const sortedData = [
    ...(Array.isArray(studResponse)
      ? studResponse.filter((op) => op.id === fdata.batch_id)
      : []),
    ...(Array.isArray(studResponse)
      ? studResponse.filter((op) => op.id !== fdata.batch_id)
      : []),
  ];
  // Retrieve data based on the activeTab
  const studResponseData = sortedData?.[activeTab]?.student_list || [];
  // Calculate total records
  const totalRecords = studResponseData?.length;
  // Paginate data
  const paginatedData = studResponseData?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${fdata.qpath}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };
  const handleSyllabusDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${fdata.syllabus_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };
  const handleAnswersBookletDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${fdata.answer_booklet_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };

  const handleAnswersKeyDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${fdata.answer_key_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };
  const handleShows = (doE) => {
    setOpens(true);
  };
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData1();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata1();
    }
  };
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };
  const handleCheckboxChangs = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "batch_name") {
      if (checked) {
        setBatch_name([{ id: value, name: name, type: "batch_name" }]);
      } else {
        setBatch_name(batch_name.filter((item) => item.id !== value));
      }
    } else if (typename === "section") {
      if (checked) {
        setSection([{ id: value, name: name, type: "section" }]);
      } else {
        setSection(section.filter((item) => item.id !== value));
      }
    } else if (typename === "schedule") {
      if (checked) {
        setSchedule([{ id: value, name: name, type: "schedule" }]);
      } else {
        setSchedule(schedule.filter((item) => item.id !== value));
      }
    } else if (typename === "class_mode") {
      if (checked) {
        setClassMode([{ id: value, name: name, type: "class_mode" }]);
      } else {
        setClassMode(classMode.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([{ id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (typename === "location") {
      if (checked) {
        setLocations([{ id: value, name: name, type: "location" }]);
      } else {
        setLocations(locations.filter((item) => item.id !== value));
      }
    } else if (typename === "status") {
      if (checked) {
        setStatus([{ id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    }
  };
  function updateStateDatas() {
    filterBatchName = batch_name;
    filterSection = section;
    filterClassMode = classMode;
    filterSchedule = schedule;
    filterLocation = locations;
    filterMedium = medium_on;
    filterStatus = status;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }
  const generatePDF = () => {
    const headers = [
      "S.No",
      "Student Name",
      "Email",
      "Phone Number",
      "Batch Name",
      "Section",
      "Medium",
      "Class Mode",
      "Schedule Preference",
      "Location",
      "Status",
    ];

    const rows = csvData.map((item, index) => [
      index + 1,
      item.name ?? "-",
      item.email ?? "-",
      item.phone_no ?? "-",
      item.batch_name ?? "-",
      item.section ?? "-",
      item.medium ?? "-",
      item.class_mode ?? "-",
      item.batch_type ?? "-",
      item.location ?? "-",
      item.status == 0 ? "Absent" : "Present",
    ]);
    navigate("/preview", {
      state: {
        title: "Individual Books Data",
        headers,
        rows,
        filename: "IndividualBooks.pdf",
        autoPrint: true,
      },
    });
  };

  const handleBackFilter = () => {
    if (fdata.event_type == 1) {
      navigate(`/TestList`, {
        state: {
          filStatus: STATUS,
        },
      });
    } else {
      // ClassList expects full filter set
      navigate("/ClassList", {
        state: {
          filCategory: CATEGORY || [], // Preserve original naming
          filCourse: COURSE || [],
          filSubject: SUBJECT || [],
          filTesttopic: TESTTOPIC || [],
          filTime: TIME || [],
          filStatus: STATUS || [],
          filSearch: SEARCHTERM || "",
          filEventType: EVENTTYPE || EVENT_TYPE || fdata.event_type,
          filActiveTab: ACTIVE_TAB, // Map event_type to tab
        },
      });
    }
  };

  const ORGANIZERID = localStorage.getItem("ORGANIZERID");
  const fetchAttendanceReportCSV = async (
    accessToken,
    meetingId,
    organizerId
  ) => {
    if (!accessToken) return console.error("AccessToken missing!");
    const client = Client.init({
      authProvider: (done) => done(null, accessToken),
    });
    setIsLoading(true);
    try {
      const report = await client

        .api(`/me/onlineMeetings/${meetingId}/attendanceReports`)

        .version("beta")
        .get();
      const attendanceReportId = report.value[0].id;
      const recordsResponse = await client

        .api(
          `/me/onlineMeetings/${meetingId}/attendanceReports/${attendanceReportId}/attendanceRecords`
        )
        .version("beta")
        .get();
      if (!recordsResponse.value || recordsResponse.value.length === 0) {
        setIsLoading(false);
        console.warn("No attendance records found yet.");
        return false;
      }
      if (recordsResponse.value && recordsResponse.value.length > 0) {
        const datas = {
          id: id,
          email:
            recordsResponse.value
              ?.map((item) => item.emailAddress)
              .filter(
                (email) => email !== null && email !== undefined && email !== ""
              ) || [],
        };

        AxiosInstance.post("api/event/class/attendance", datas).then((res) => {
          setIsLoading(false);

          findById(id);
          window.open(
            `${ImageUrlPrefix}/${res.data.attendance_frame_set}`,
            "_blank"
          );
        });
        return true; // report generated successfully
      }
      return false; // report not ready yet
    } catch (error) {
      console.error("Error fetching attendance:", error);
      return false;
    }
  };
  const handleGenerateReport = async () => {
    const tesamMeeting_id = resData.teams_id;
    if (!tesamMeeting_id) {
      window.open(`${ImageUrlPrefix}/${fdata.attendance_sheet_path}`, "_blank");
    } else {
      const accessToken = await getAccessToken();

      try {
        const accessToken = await getAccessToken();
        const teamsMeetingId = resData.teams_id;

        // End meeting now
        const nowUTC = moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]");

        const response = await axios.patch(
          `https://graph.microsoft.com/v1.0/me/onlineMeetings/${teamsMeetingId}`,
          {
            subject: subTopic[0].subject_name,
            startDateTime: moment(fdata.startTime, "HH:mm:ss")
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]"),
            endDateTime: nowUTC, // End meeting now
            isEntryExitAnnounced: false,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        setTimeout(async () => {
          await axios.delete(
            `https://graph.microsoft.com/v1.0/me/onlineMeetings/${teamsMeetingId}`,
            { headers: { Authorization: `Bearer ${accessToken.accessToken}` } }
          );
        }, 2000);

        console.log("Meeting ended successfully:", response.data);
      } catch (error) {
        console.error(
          "Error ending meeting:",
          error.response?.data || error.message
        );
      }
      if (!accessToken.accessToken || !tesamMeeting_id) {
        setIsLoading(false);
        console.error("Missing required data for fetching attendance!");
        return;
      }

      try {
        const success = await fetchAttendanceReportCSV(
          accessToken.accessToken,
          tesamMeeting_id,
          ORGANIZERID
        );

        if (!success) {
          setIsLoading(false);

          toast.error("Attendance report not ready or no records available.");
          console.log("Attendance report not ready or no records available.");
        }
      } catch (error) {
        console.error("Error fetching attendance:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${styles.DetaitlTestViewMainHeader} BathDet global_container container-fluid BathHeader`}
    >
      <div className="row">
        <div className=" col-md-3 col-12 ">
          <h2 className="TitleHeader ">
            {" "}
            {fdata.event_type == 1 ? "View Test" : "View Class"}{" "}
          </h2>
        </div>

        <div className="col-md-9 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                // onClick={() =>
                //   handleBackFilter(`/DetailViewBatch/${batch_id}/${4}`)
                // }
                // to={`/DetailViewBatch/${batch_id}/${4}`}
                // className="secondaryButton "
                // to={fdata.event_type == 1 ? "/TestList" : "/ClassList"}
                onClick={handleBackFilter}
                to="javascript:void(0)"
                className={
                  status === "1" && fdata.qpath !== null
                    ? "secondaryButton"
                    : "secondaryButton"
                }
              >
                {fdata.event_type == 1 ? "Back to Test" : "Back to Class"}
              </Link>
            </li>
            {!((isSameDay && isAfterStartTime) || isAfterStartDate) &&
              fdata.event_type == 1 && (
                <li class="ListBtnItems">
                  {type !== "4" && (
                    <button
                      type="button"
                      disabled={
                        (isSameDay && isAfterStartTime) || isAfterStartDate
                      }
                      className={`${styles.detailEventButton}  ms-2 ${(isSameDay && isAfterStartTime) || isAfterStartDate
                          ? styles.DisabledListviS
                          : ""
                        }`}
                      onClick={Upload_Question}
                    >
                      <span class="material-icons me-1">upload</span>
                      <a href="javascript:void(0)">Upload New Question Paper</a>
                    </button>
                  )}
                </li>
              )}

            {/* {fdata.classMode == "Online" && (
              <li class="ListBtnItems">
                <Link
                  to={"javascript:void(0)"}
                  disabled={isPolling}
                  onClick={handleGenerateReport}
                  className={`primaryButton `}
                >
                  <div className=" d-flex">
                    <span >
                      {isPolling ? "Generating..." : "Generate Reports"}

                    </span>
                  </div>
                </Link>
              </li>
            )} */}
         
            {fdata.batch_types != 5 && fdata.event_type == 0 && (
              <li class="ListBtnItems">
                <Link
                  onClick={handleGenerateReport}
                  to={"javascript:void(0)"}
                  className={`primaryButton `}
                  variant="primary"
                // disabled={isPolling}
                >
                  Download Attendance Frame Set
                </Link>
              </li>
            )}

            {fdata.attendance_sheet_path !== null && fdata.event_type == 0 && (
              <li class="ListBtnItems">
                <Link
                  onClick={handleShows}
                  to={"javascript:void(0)"}
                  // disabled={
                  //   !(
                  //     isAfterEndTimeONEHOUR && selectedStudents.length > 0
                  //   )
                  // }
                  className={`primaryButton `}
                  variant="primary"
                >
                  Add Url and Attendance Sheet
                </Link>
              </li>
            )}
            {fdata.qpath !== null &&
              fdata.method_of_test === 0 &&
              type !== "4" && (
                <li class="ListBtnItems">
                  <button
                    type="button"
                    className={`${styles.detailEventButtons} `}
                    onClick={() =>
                      handleNavigate(
                        isSameDay,
                        isAfterStartTime,
                        isAfterStartDate
                      )
                    }
                  >
                    {" "}
                    <span class={`material-icons me-2`}>visibility</span>
                    <a href="javascript:void(0)">View Question Paper</a>
                  </button>
                </li>
              )}

            <li class="ListBtnItems">
              {((isSameDay && isAfterEndTime) || isAfterStartDate) &&
                type !== "4" &&
                fdata.event_type == 1 &&
                fdata.method_of_test === 0 && (
                  <button
                    type="button"
                    disabled={
                      fdata.publish_results === 1 ||
                      fdata.qpath === "" ||
                      fdata.qpath === null
                    }
                    className={`${styles.detailEvenPublishtButtons} ms-2 ${fdata.publish_results === 1 ||
                        fdata.qpath === "" ||
                        fdata.qpath === null
                        ? styles.DisabledListviS
                        : ""
                      }`}
                    onClick={() => handlePublicResults()}
                  >
                    <a href="javascript:void(0)">Publish Results</a>

                    {showPublicResults && (
                      <PublicResult
                        batch_id={fdata.batch_id}
                        event_id={fdata.event_id}
                        user_id={userid}
                        handleflagReload={handleflagReload}
                      />
                    )}
                  </button>
                )}
              {/*  que status 4 means is all  Answer sheet evaluated */}
              {fdata.que_status === 4 &&
                type !== "4" &&
                fdata.event_type == 1 &&
                isAfterEndTimeONEHOUR &&
                fdata.method_of_test === 1 && (
                  <button
                    type="button"
                    disabled={fdata.publish_results === 1}
                    className={`${styles.detailEvenPublishtButtons} ms-2 ${fdata.publish_results === 1 ? styles.DisabledListviS : ""
                      }`}
                    onClick={() => handleDescriptivePublicResults()}
                  >
                    <a href="javascript:void(0)">Publish Results</a>

                    {/* {showDOpModel && ( */}
                    <DescriptivePublishResults
                      batch_id={fdata.batch_id}
                      event_id={fdata.event_id}
                      handleClose_descriptive={handleClose_descriptive}
                      user_id={userid}
                      handleflagReload={handleflagReload}
                      puResult={fdata.publish_results === 1 ? true : false}
                      showDOpModel={showDOpModel}
                    />
                    {/* )} */}
                  </button>
                )}
            </li>
          </ul>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <fieldset className="mt-3">
            <legend className="w-auto">
              {fdata.event_type == 1 ? "Test Details" : "Class Details  "}
            </legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    {" "}
                    {fdata.event_type == 1 ? "Test Name" : "Class Name"}
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.title !== null ? fdata.title : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Date</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {/* {fdata.sDate !== null ? fdata.sDate : "⎯"} */}
                    {fdata.sDate !== null
                      ? moment(fdata.sDate).format("DD/MM/YYYY")
                      : "⎯"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Start Time</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.startTime !== null
                      ? moment(fdata.startTime, "HH:mm:ss").format("h:mm A")
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> End Time</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.endTime !== null
                      ? moment(fdata.endTime, "HH:mm:ss").format("h:mm A")
                      : "_"}
                  </p>
                </div>
              </div>
              {fdata.event_type == 1 && (
                <>
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">
                        {" "}
                        Total Number of Questions
                      </p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {fdata.no_ques !== null ? fdata.no_ques : "_"}
                      </p>
                    </div>
                  </div>
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0"> Total Marks</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {fdata.tol_mark !== null ? fdata.tol_mark : "_"}
                      </p>
                    </div>
                  </div>
                </>
              )}

              {/* <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">   Test Number</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.test_num !== null ? fdata.test_num : "_"}
                  </p>
                </div>
              </div> */}

              {/* tag Line */}
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Batch Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.batchName !== null ? fdata.batchName : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Category</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.category !== null ? fdata.category : "⎯"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Course</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.course !== null ? fdata.course : "_"}
                  </p>
                </div>
              </div>
              {fdata.event_type == 1 && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Method of Test</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.method_of_test !== null
                        ? fdata.method_of_test === 1
                          ? "Descriptive"
                          : "Objective"
                        : "_"}
                    </p>
                  </div>
                </div>
              )}
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Class Mode</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.classMode !== null ? fdata.classMode : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Medium</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.medium !== null ? fdata.medium : "⎯"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Location</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.location !== null && fdata.location !== ""
                      ? fdata.location
                      : "⎯"}
                  </p>
                </div>
              </div>
              {fdata.event_type == 1 && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Cut Off</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.cutOff ? fdata.cutOff : "_"}
                    </p>
                  </div>
                </div>
              )}

              {/* {type !== "1" && (
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0"> Subject</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {" "}
                          {fdata.subject ?? "_"}
                        </p>
                      </div>
                    </div>
                  )} */}
              <>
                {fdata.event_type == 1 && (
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0"> Status</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {fdata.que_status === 0 && "Questions Not Yet Uploaded"}
                        {fdata.que_status === 1 && "Questions Uploaded"}
                        {fdata.que_status === 2 &&
                          (isAfterEndTimeONEHOUR === true
                            ? "Answer Sheet Uploaded"
                            : "Questions Uploaded")}
                        {fdata.que_status === 3 && "Assigned to Evaluators"}
                        {fdata.que_status === 4 && "Answer Sheet Evaluated"}
                        {fdata.que_status === 5 && "Results Published"}
                      </p>
                    </div>
                  </div>
                )}

                {fdata.event_type == 0 && (
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0"> Status</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {fdata.que_status === 0 && "Upcoming"}
                        {fdata.que_status === 1 && "Ongoing"}
                        {fdata.que_status === 2 &&
                          "Attendence Sheet not yet upload"}
                        {fdata.que_status === 3 && "Completed"}
                      </p>
                    </div>
                  </div>
                )}
              </>
              {/* {fdata.event_type == 0 && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Test Topic</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.test_topic !== null ? fdata.test_topic : "_"}
                    </p>
                  </div>
                </div>
              )} */}

              {fdata.event_type == 0 && (
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Faculty Name</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.staff_name !== null ? fdata.staff_name : "⎯"}
                    </p>
                  </div>
                </div>
              )}

              <div className="my-1  col-md-12 ">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    {" "}
                    Instruction to Student
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.description !== null ? fdata.description : "⎯"}
                  </p>
                </div>
              </div>
              {fdata.event_type == 0 && (
                <div className="my-1  col-md-12 ">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">
                      {" "}
                      Instruction to faculty
                    </p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.staff_description !== null
                        ? fdata.staff_description
                        : "_"}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </fieldset>

          <fieldset className="mt-3">
            <legend className="w-auto">Subjects and Topics</legend>
            <div className="row mb-3">
              <div className="my-1  col-md-12 ">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">Uploaded Syllabus </p>{" "}
                    {fdata.syllabus_path !== "" &&
                      fdata.syllabus_path !== null && (
                        <>
                          <a
                            to="javascript:void(0)"
                            onClick={() =>
                              handleDownloadSyllabus(fdata.syllabus_path)
                            }
                            download
                          >
                            <span className="material-icons align-middle download_icon">
                              file_download
                            </span>
                          </a>
                        </>
                      )}
                  </div>

                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.syllabus_path || "_"}
                  </p>
                </div>
              </div>
              {subTopic.length > 0 ? (
                subTopic.map((onk) => {
                  return (
                    <>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0"> Subject</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {" "}
                            {onk.subject_name || "-"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">
                            {" "}
                            {fdata.event_type == 0
                              ? "Class Topics"
                              : "Test Topics"}{" "}
                          </p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {" "}
                            {onk.test_topics
                              .map((el) => el.test_topic)
                              .join(", ") || "-"}
                          </p>
                        </div>
                      </div>
                    </>
                  );
                })
              ) : (
                <>
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0"> Subject</p>
                      <p className="confirm_value my-1 m-0 p-0">{"-"}</p>
                    </div>
                  </div>
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0"> Test Topics</p>
                      <p className="confirm_value my-1 m-0 p-0">{"-"}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </fieldset>

          {/* <section className={`${styles.StepOne}`}>
            <div className={`${styles.box} row`}>
              <div className="col-md-12 pb-2">
                <p className={`${styles.StepTitle}`}>
                  Other Applicable Batches
                </p>
                <div className="row">
                  <div className="col-md-12">
                    <div className={`${styles.forms}`}>
                      <label htmlFor="inputName" className="text-muted">
                        Other Applicable Batches
                      </label>
                      <span className={`${styles.ReviewLabel}`}>
                        {otherApplic.length > 0
                          ? otherApplic.map((onk) => onk.name).join(", ")
                          : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          <fieldset className="mt-3">
            <legend className="w-auto">Other Applicable Batches</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    {" "}
                    Other Applicable Batches
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {otherApplic.length > 0 ? (
                      <>
                        {otherApplic.map((lk, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && ", "}{" "}
                            {/* Add comma and space for elements after the first one */}
                            {lk.name}({lk.section})
                          </React.Fragment>
                        ))}
                      </>
                    ) : (
                      <p className="confirm_value my-1 m-0 p-0">_</p>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
          {fdata.event_type == 0 && (
            <fieldset className="mt-3">
              <legend className="w-auto">
                Recording URL and Attendance Sheet
              </legend>
              <div className="row mb-3">
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">
                      {" "}
                      Recording URL and Attendee
                    </p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {fdata.recording_url || "_"}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex">
                      <p className="confirm_label m-0 p-0"> Attendance Sheet</p>{" "}
                      {/* {fdata.attendance_sheet_path !== "" &&
                        fdata.attendance_sheet_path !== null && (
                          <>
                            <a
                              to="javascript:void(0)"
                              onClick={() =>
                                handleDownload(
                                  fdata.original_answer_sheet_path,
                                  fdata.original_answer_sheet_path
                                )
                              }
                              // target="_blank"
                              download
                            >
                              <span className="material-icons align-middle download_icon">
                                file_download
                              </span>
                            </a>
                          </>
                        )} */}
                    </div>

                    <p className="confirm_value my-1 m-0 p-0">
                      {fdata.original_attendancesheet_file_path || "_"}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          )}

          {fdata.method_of_test == 1 && (
            <section className={`${styles.StepOne} `}>
              <div className={`${styles.box} row`}>
                <div className="col-md-12 pb-2">
                  <p className={`${styles.StepTitle} `}>Combined Tests</p>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Combined Tests
                        </label>

                        {combineTest.length > 0 ? (
                          <span className={styles.ReviewLabel}>
                            {combineTest.map((op) => op.name).join(", ")}
                          </span>
                        ) : (
                          <span className={styles.ReviewLabel}>-</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {fdata.event_type == 1 && fdata.method_of_test == 0 && (
            <section className={`${styles.StepOne} `}>
              <div className={`${styles.box} row`}>
                <div className="col-md-12 pb-2">
                  <p className={`${styles.StepTitle} `}>
                    Uploaded Question Paper
                  </p>
                  <div className="row ">
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Uploaded Question Paper
                          {fdata.qpath !== "" && fdata.qpath !== null && (
                            <a
                              href={`${ImageUrlPrefix}/${fdata.qpath}`}
                              target="_blank"
                              download
                            >
                              <span className="material-icons align-middle download_icon">
                                file_download
                              </span>
                            </a>
                          )}
                        </label>
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.qpath !== null ? (
                            <a
                              target="_blank"
                              className={`${styles.questionpapers}`}
                              href={`${ImageUrlPrefix}/${fdata.qpath}`}
                            >
                              {fdata.qpath_original_path}
                            </a>
                          ) : (
                            "⎯"
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Cut-Off
                        </label>
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.cutOff !== null ? fdata.cutOff : "⎯"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {fdata.method_of_test == 1 && (
            <section className={`${styles.StepOne} `}>
              <div className={`${styles.box} row`}>
                <div className="col-md-12 pb-2">
                  <p className={`${styles.StepTitle} `}> Question Paper</p>
                  <div className="row ">
                    {/* 1 */}
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Question Paper
                          {fdata.qpath !== "" && fdata.qpath !== null && (
                            <>
                              <a
                                to="javascript:void(0)"
                                onClick={() =>
                                  handleDownload(
                                    fdata.qpath,
                                    fdata.qpath_original_path
                                  )
                                }
                              >
                                <span className="material-icons align-middle download_icon">
                                  file_download
                                </span>
                              </a>
                              <a
                                href={`${ImageUrlPrefix}/${fdata.qpath}`}
                                target="_blank"
                                styles={{ marginTop: "5px" }}
                              >
                                <span
                                  className={`${styles.viewIcon} material-icons align-middle download_icon `}
                                >
                                  visibility
                                </span>
                              </a>
                            </>
                          )}
                        </label>
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.qpath !== null && fdata.qpath !== "" ? (
                            <a
                              target="_blank"
                              className={`${styles.questionpapers}`}
                              href={`${ImageUrlPrefix}/${fdata.qpath}`}
                            >
                              {fdata.qpath_original_path}
                            </a>
                          ) : (
                            "⎯"
                          )}
                        </span>
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Answer Booklet
                          {fdata.answer_booklet_path !== "" &&
                            fdata.answer_booklet_path !== null && (
                              <>
                                {/* <a
                                to="javascript:void(0)"
                                onClick={() =>
                                  handleAnswersBookletDownload(
                                    fdata.answer_booklet_path,
                                    fdata.answer_booklet_original_path
                                  )
                                }
                              ></a>
                                <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span> */}

                                <a
                                  to="javascript:void(0)"
                                  onClick={() =>
                                    handleAnswersBookletDownload(
                                      fdata.answer_booklet_path,
                                      fdata.answer_booklet_original_path
                                    )
                                  }
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                                {/* <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_booklet_path}`}
                                  target="_blank"
                                  download
                                >
                                
                                </a> */}
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_booklet_path}`}
                                  target="_blank"
                                >
                                  <span
                                    className={`${styles.viewIcon} material-icons align-middle download_icon `}
                                  >
                                    visibility
                                  </span>
                                </a>
                              </>
                            )}
                        </label>

                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.answer_booklet_path !== "" &&
                            fdata.answer_booklet_path !== null ? (
                            <a
                              target="_blank"
                              className={`${styles.questionpapers}`}
                              href={`${ImageUrlPrefix}/${fdata.answer_booklet_path}`}
                            >
                              {fdata.answer_booklet_original_path
                                ? fdata.answer_booklet_original_path
                                : "_"}
                            </a>
                          ) : (
                            "⎯"
                          )}
                        </span>
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Question Frame Set
                          {fdata.question_frameset_path !== "" &&
                            fdata.question_frameset_path !== null && (
                              <>
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.question_frameset_path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                              </>
                            )}
                        </label>
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.question_frameset_path !== null ? (
                            <a
                              target="_blank"
                              className={`${styles.questionpapers}`}
                              href={`${ImageUrlPrefix}/${fdata.question_frameset_path}`}
                            >
                              {fdata.question_frameset_original_path}
                            </a>
                          ) : (
                            "⎯"
                          )}
                        </span>
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Answer Key
                          {fdata.answer_key_path !== "" &&
                            fdata.answer_key_path !== null && (
                              <>
                                {/* <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_key_path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a> */}
                                <a
                                  to="javascript:void(0)"
                                  onClick={() =>
                                    handleAnswersKeyDownload(
                                      fdata.answer_key_original_path,
                                      fdata.answer_key_path
                                    )
                                  }
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                                <a
                                  href={`${ImageUrlPrefix}/${fdata.answer_key_path}`}
                                  target="_blank"
                                >
                                  <span
                                    className={`${styles.viewIcon} material-icons align-middle download_icon `}
                                  >
                                    visibility
                                  </span>
                                </a>
                              </>
                            )}
                        </label>
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.answer_key_path !== null ? (
                            <a
                              target="_blank"
                              className={`${styles.questionpapers}`}
                              href={`${ImageUrlPrefix}/${fdata.answer_key_path}`}
                            >
                              {fdata.answer_key_original_path}
                            </a>
                          ) : (
                            "⎯"
                          )}
                        </span>
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Cut-Off
                        </label>
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.cutOff !== null ? fdata.cutOff : "⎯"}
                        </span>
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="col-md-3">
                      <div className={`${styles.forms}`}>
                        <label htmlFor="inputName" className={` text-muted`}>
                          Double Evaluation
                        </label>
                        <span className={`${styles.ReviewLabel}`}>
                          {fdata.double_evaluation === 1 && "Yes"}
                          {fdata.double_evaluation === 0 && "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {fdata.event_type == 1 && fdata.method_of_test == 0 && (
            <section className={`${styles.StepOne} `}>
              <div className={`${styles.box} row`}>
                <div className="col-md-12 pb-2">
                  <p className={`${styles.StepTitle} `}>
                    Question Paper Details
                  </p>
                  {quesdata.length > 0 ? (
                    quesdata.map((el, index) => (
                      <div className="row" key={index}>
                        <div className="col-md-3">
                          <div className={`${styles.forms}`}>
                            <h5 className="Question_label">Subject</h5>
                            <span className={`${styles.ReviewLabel}`}>
                              {el.subject !== null && el.subject !== ""
                                ? el.subject
                                : "⎯"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className={`${styles.forms}`}>
                            <h5 className="Question_label">
                              Total Number of Questions
                              <span
                                className={el.medium.length > 12 ? "Sil" : ""}
                              >
                                ({el.medium})
                              </span>
                            </h5>
                            <span className={`${styles.ReviewLabel}`}>
                              {el.no_ques !== null && el.no_ques !== ""
                                ? el.no_ques
                                : "⎯"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className={`${styles.forms}`}>
                            <h5 className="Question_label">
                              Very Easy Questions{" "}
                              <span
                                className={el.medium.length > 12 ? "Sil" : ""}
                              >
                                ({el.medium})
                              </span>
                            </h5>
                            <span className={`${styles.ReviewLabel}`}>
                              {el.very_easy_ques !== null &&
                                el.very_easy_ques !== ""
                                ? el.very_easy_ques
                                : "⎯"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className={`${styles.forms}`}>
                            <h5 className="Question_label">
                              Easy Questions{" "}
                              <span
                                className={el.medium.length > 12 ? "Sil" : ""}
                              >
                                ({el.medium})
                              </span>
                            </h5>
                            <span className={`${styles.ReviewLabel}`}>
                              {el.easy_ques !== null && el.easy_ques !== ""
                                ? el.easy_ques
                                : "⎯"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className={`${styles.forms}`}>
                            <h5 className="Question_label">
                              Medium Questions
                              <span
                                className={el.medium.length > 12 ? "Sil" : ""}
                              >
                                ({el.medium})
                              </span>
                            </h5>
                            <span className={`${styles.ReviewLabel}`}>
                              {el.med_ques !== null && el.med_ques !== ""
                                ? el.med_ques
                                : "⎯"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className={`${styles.forms}`}>
                            <h5 className="Question_label">
                              Hard Questions{" "}
                              <span
                                className={el.medium.length > 12 ? "Sil" : ""}
                              >
                                ({el.medium})
                              </span>
                            </h5>
                            <span className={`${styles.ReviewLabel}`}>
                              {el.hard_ques !== null && el.hard_ques !== ""
                                ? el.hard_ques
                                : "⎯"}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className={`${styles.forms}`}>
                            <h5 className="Question_label">
                              Very Hard Questions{" "}
                              <span
                                className={el.medium.length > 12 ? "Sil" : ""}
                              >
                                ({el.medium})
                              </span>
                            </h5>
                            <span className={`${styles.ReviewLabel}`}>
                              {el.very_hard_ques !== null &&
                                el.very_hard_ques !== ""
                                ? el.very_hard_ques
                                : "⎯"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="row mt-2">
                      <div className="col-md-3">
                        <div className={`${styles.forms}`}>
                          <span className={`${styles.ReviewLabel}`}>
                            No records to display{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
          {fdata.method_of_test == 0 &&
            viewQueries.length > 0 &&
            viewQueries.map((el, index) => (
              <section className={`${styles.StepOne} `}>
                <div className={`${styles.box} row`}>
                  <div className="col-md-12 pb-2">
                    <p className={`${styles.StepTitle} `}>
                      Query - Question No:{el.ques_no}
                    </p>
                    <div className="row mt-3">
                      <div className="col-md-12 p-0">
                        {el.display_type === 0 && (
                          <RtypeOne type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 1 && (
                          <RtypeTwo type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 2 && (
                          <RtypeThree type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 3 && (
                          <RtypeFour type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 4 && (
                          <RtypeFive type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 5 && (
                          <RtypeSix type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 6 && (
                          <RtypeSeven type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 7 && (
                          <RtypeEight type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 8 && (
                          <RtypeNine type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 9 && (
                          <RtypeTen type={"2"} index={index} list={el} />
                        )}
                        {el.display_type === 10 && (
                          <>
                            {el.para_text_en !== "" && (
                              <Rtypepara
                                type={"2"}
                                classET={"question_labels_english"}
                                index={index}
                                list={el.para_text_en}
                              />
                            )}
                            {el.para_text_tm !== "" && (
                              <Rtypepara
                                type={"2"}
                                classET={"question_labels_tamil"}
                                index={index}
                                list={el.para_text_tm}
                              />
                            )}

                            <RtypeParaOption
                              type={"2"}
                              index={index}
                              list={el}
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <ExplanationQuery
                      lang_type={el.lang_type}
                      margin_yes={0}
                      en_explan={el.en_explanation}
                      tm_expla={el.tm_explanation}
                    />
                    <div className="BorderQuery"></div>
                    {el.stud_query &&
                      el.stud_query.map((ojk, index) => {
                        return <QuerySection query_rise={ojk} index={index} />;
                      })}
                    <div className="BorderQuery"></div>
                    <div className="row mt-3 mb-4">
                      <div className="col-md-6 ">
                        {el.assignee_info === null ||
                          (el.assignee_info !== null && el.isEdit === true) ? (
                          <div className={`${styles.forms}`}>
                            <label for="assign_to mt-0" id="assign_to_id">
                              Assign To
                            </label>
                            <Select
                              id="assign_to"
                              name="assign_to"
                              options={staffMem}
                              isSearchable={true}
                              isClearable={true}
                              onChange={(option) =>
                                handleAssign(
                                  option,
                                  "assign_to",
                                  el.question_pk
                                )
                              }
                              placeholder="Select an faculty"
                              value={
                                el.IsFaculty_id !== null &&
                                el.isFaculty_name !== "" && {
                                  staff_id: el.IsFaculty_id,
                                  value: el.isFaculty_name,
                                  label: el.isFaculty_name,
                                  questionPk: el.questionPk,
                                }
                              }
                              styles={customStyles}
                            />

                            {el.isFaculty_error && (
                              <p className="errors">{el.isFaculty_error}</p>
                            )}
                          </div>
                        ) : (
                          <div className={`${styles.forms}`}>
                            <p
                              for="assign_to mt-0"
                              className="titleQuery mb-0"
                              id="assign_to_id"
                            >
                              Assign To
                            </p>
                            <span className="ReviewLabel mt-2">
                              {el.assignee_info !== null &&
                                el.assignee_info.assigned_to_name}
                            </span>
                          </div>
                        )}
                      </div>
                      {el.assignee_info !== null &&
                        (el.assignee_info.reply_by_staff !== null ||
                          el.assignee_info.reply_by_staff !== "") &&
                        el.IsfacultyUpdate === true && (
                          <>
                            <div className="col-md-6 ">
                              <div className={`${styles.forms}`}>
                                <p
                                  for="assign_to mt-0"
                                  className="titleQuery mb-0"
                                  id="assign_to_id"
                                >
                                  Query Status
                                </p>
                                <span className="ReviewLabel mt-2">
                                  {el.assignee_info.query_status === 1
                                    ? "Valid"
                                    : "Invalid"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-6 ">
                              <div className={`${styles.forms}`}>
                                <p
                                  for="assign_to mt-0"
                                  className="titleQuery mt-2 mb-0"
                                  id="assign_to_id"
                                >
                                  Reply by {el.assignee_info.assigned_to_name} (
                                  {moment(el.assignee_info.reply_dt).format(
                                    "DD/MM/YYYY hh:mm A"
                                  )}
                                  )
                                </p>
                                <span className="ReviewLabel mt-2">
                                  {el.assignee_info.reply_by_staff
                                    ? el.assignee_info.reply_by_staff
                                    : "_"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className={`${styles.forms}`}>
                                <div class="d-flex">
                                  {" "}
                                  <p className="titleQuery mb-1">Attachments</p>
                                  <a
                                    download
                                    className="attachmentQuery"
                                    href={`${ImageUrlPrefix}/${el.assignee_info &&
                                        el.assignee_info.query_proof_filepath
                                        ? el.assignee_info.query_proof_filepath
                                        : null
                                      }`}
                                  >
                                    <span class="material-icons iconQuery">
                                      download
                                    </span>
                                  </a>
                                  <a
                                    className="attachmentQuery"
                                    target="_blank"
                                    href={`${ImageUrlPrefix}/${el.assignee_info &&
                                        el.assignee_info.query_proof_filepath
                                        ? el.assignee_info.query_proof_filepath
                                        : null
                                      }`}
                                  >
                                    <span class="material-icons iconQuery">
                                      visibility
                                    </span>
                                  </a>
                                </div>

                                <p className="explain_ques mt-0">
                                  {" "}
                                  {el.assignee_info !== null &&
                                    el.assignee_info.original_query_filepath}
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                      {/* {console.log(el, "el")} */}
                      {el.assignee_info !== null &&
                        (el.assignee_info.reply_by_staff !== null ||
                          el.assignee_info.reply_by_staff !== "") &&
                        el.IsFacultyEdit === true && (
                          <>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                              <div className={`${styles.forms}`}>
                                <label for="query_status">Query Status:</label>
                                <select
                                  ref={txtQueryStatus}
                                  id="query_status"
                                  name="query_status"
                                  className="Inputs"
                                  onChange={(e) => handleChange(e, el)}
                                  required
                                >
                                  <option value="" disabled>
                                    Please select
                                  </option>
                                  <option
                                    selected={
                                      el.query_status === "1" ? true : false
                                    }
                                    value="1"
                                  >
                                    Valid
                                  </option>
                                  <option
                                    selected={
                                      el.query_status === "0" ? true : false
                                    }
                                    value="0"
                                  >
                                    Invalid
                                  </option>
                                </select>
                                {el.query_Status_error && (
                                  <small className="error">
                                    {el.query_Status_error}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 ">
                              <div className={`${styles.forms}`}>
                                <label for="query_path">
                                  Upload Proof for Query Reference:
                                  {el.query_path !== "" &&
                                    el.query_path !== null && (
                                      <a
                                        href={`${ImageUrlPrefix}/${el.query_path}`}
                                        download
                                      >
                                        <span className="material-icons download_icon align-middle text-danger ">
                                          file_download
                                        </span>
                                      </a>
                                    )}
                                </label>
                                <div className="row">
                                  <div
                                    className={
                                      el.query_path !== "" &&
                                        el.query_path !== null
                                        ? "col-md-3 "
                                        : "col-md-12"
                                    }
                                  >
                                    <input
                                      ref={txtQueryPath}
                                      id="query_path"
                                      type="file"
                                      name="query_path"
                                      placeholder="Upload query proof"
                                      className={
                                        el.query_path !== "" &&
                                          el.query_path !== null
                                          ? "InputsFile nn_upload_width"
                                          : "InputsFile  vv_upload_width"
                                      }
                                      onChange={(e) => handleChange(e, el)}
                                      autoComplete="query_path"
                                      required
                                    />
                                  </div>
                                  {el.query_path !== "" &&
                                    el.query_path !== null && (
                                      <div
                                        className={
                                          "col-md-9 d-flex align-content-center p-0"
                                        }
                                      >
                                        <span className="nn_upload_file">
                                          {el.original_query_path}
                                        </span>
                                        <span className="material-icons align-middle text-danger verified_upload">
                                          verified
                                        </span>
                                      </div>
                                    )}
                                </div>
                                {el.query_path_error && (
                                  <small className="error">
                                    {el.query_path_error}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className={`${styles.forms}`}>
                                <label for="reply_query">Reply by You:</label>
                                <textarea
                                  ref={txtQueryReply}
                                  id="reply_query"
                                  className="textareaInput"
                                  name="reply_query"
                                  rows="4"
                                  cols="20"
                                  onChange={(e) => handleChange(e, el)}
                                  placeholder="Reply by You"
                                  value={el.reply_query}
                                ></textarea>
                                {el.reply_status_error && (
                                  <small className="error">
                                    {el.reply_status_error}
                                  </small>
                                )}
                              </div>
                            </div>
                          </>
                        )}

                      {el.query_stage === 0 && (
                        <div className="heading mt-4 dflexCenter ">
                          {el.assignee_info === null ||
                            (el.assignee_info !== null && el.isEdit === true) ||
                            el.IsFacultyEdit === true ? (
                            <>
                              {el.isUpdate === false && (
                                <Link
                                  to="javascript:void(0)"
                                  onClick={() => handleCancel(el)}
                                  className="CancelButton"
                                >
                                  Cancel
                                </Link>
                              )}
                              <button
                                type="button"
                                className="QueryButton"
                                onClick={
                                  el.IsFacultyEdit === true
                                    ? () => handleUpdateApprove(el)
                                    : () => handleAssignTo(el)
                                }
                              >
                                <Link to="javascript:void(0)">
                                  {el.assignee_info !== null &&
                                    el.isEdit === false
                                    ? el.IsfacultyUpdate === true
                                      ? "Update"
                                      : "Update and Approve"
                                    : el.isEdit === true
                                      ? "Update"
                                      : "Assign Now"}
                                </Link>
                              </button>
                            </>
                          ) : (
                            <>
                              {el.assignee_info !== null &&
                                (el.assignee_info.reply_by_staff === "" ||
                                  el.assignee_info.reply_by_staff === null) ? (
                                <>
                                  <button
                                    onClick={() => handleEditAssignTo(el)}
                                    type="button"
                                    className="QueryEditButton"
                                  >
                                    <Link to="javascript:void(0)">
                                      <span class="material-icons me-2">
                                        border_color
                                      </span>
                                      Edit
                                    </Link>
                                  </button>
                                  <button
                                    onClick={() => handleRemindMeAgain(el)}
                                    type="button"
                                    className=" ms-4 QueryRemindButton"
                                  >
                                    <Link to="javascript:void(0)">
                                      Remind Again
                                    </Link>
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    onClick={() => handleEditFaculty(el)}
                                    type="button"
                                    className="QueryEditButton"
                                  >
                                    <Link to="javascript:void(0)">
                                      <span class="material-icons me-2">
                                        border_color
                                      </span>
                                      Edit
                                    </Link>
                                  </button>

                                  <button
                                    type="button"
                                    onClick={() => handleApprove(el)}
                                    className=" ms-4 QueryRemindButton"
                                  >
                                    <Link to="javascript:void(0)">Approve</Link>
                                  </button>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            ))}
        </div>
      </div>
      {fdata.method_of_test == 1 && (
        <div className={`${styles.viewTestListMain}  `}>
          <div className="row m-0">
            <fieldset className="mt-3">
              <legend className="w-auto">Student List</legend>
              {updateChipData.filter((kl) => kl.name !== "ActiveTab").length >
                0 ? (
                <div className="row mt-3">
                  <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {updateChipData
                        .filter((kl) => kl.name !== "ActiveTab")
                        .map((data, index) => {
                          // console.log(data, " - data - ", index);
                          let icon;
                          let key = "" + data.name;
                          return (
                            <ListItem key={data}>
                              <Chip
                                icon={icon}
                                label={key}
                                onDelete={handleDelete(data, index)}
                              />
                            </ListItem>
                          );
                        })}

                      <ListItem className="clearAll_list">
                        <a
                          className="clearAll_listItem"
                          href="javascript:void(0)"
                          onClick={handleAllClear}
                        >
                          Clear All Filters
                        </a>
                      </ListItem>
                    </Paper>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div className="row ">
                <div className="offset-md-12 col-12 ListBtn">
                  <ul class="List-Button">
                    <li class="ListBtnItems">
                      <Link
                        onClick={
                          isAfterEndTimeONEHOUR && selectedStudents.length > 0
                            ? () => handleShow(fdata.double_evaluation)
                            : () => { }
                        }
                        to={"javascript:void(0)"}
                        disabled={
                          !(
                            isAfterEndTimeONEHOUR && selectedStudents.length > 0
                          )
                        }
                        className={`primaryButton ${!(
                            isAfterEndTimeONEHOUR && selectedStudents.length > 0
                          )
                            ? "disabledbtn"
                            : ""
                          }`}
                        variant="primary"
                      >
                        Assign to Evaluator
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <div
                  className={`${studResponse?.length === 0
                      ? "d-none "
                      : "course-content-nav"
                    }  mb-3 d-flex `}
                >
                  {studResponse?.length > 0 ? (
                    [
                      ...studResponse?.filter(
                        (op) => op.id === fdata.batch_id // Filter for matching batch_id
                      ),
                      ...studResponse?.filter(
                        (op) => op.id !== fdata.batch_id // Filter for non-matching batch_id
                      ),
                    ].map((item, itemIndex) => (
                      <>
                        <div>
                          <ul
                            className="nav"
                            id={`tabList-${itemIndex}`}
                            role="tablist"
                            key={itemIndex}
                          >
                            <li className="nav-item" role="presentation">
                              <button
                                className={
                                  activeTab === itemIndex
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                id={`tab-${itemIndex}`}
                                data-bs-toggle="tab"
                                data-bs-target={`#tab-pane-${itemIndex}`}
                                type="button"
                                role="tab"
                                aria-controls={`tab-pane-${itemIndex}`}
                                aria-selected={activeTab === itemIndex}
                                onClick={() =>
                                  handleTabClick(
                                    itemIndex,
                                    item.batch_id,
                                    item.batch_type
                                  )
                                }
                              >
                                {`${item.name} (${item.Null_count}/${item.total_count})`}
                              </button>
                            </li>
                          </ul>
                        </div>
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                </div>

                <div className="row mx-0">
                  <div className="col-md-12  tableMinHeight table-responsive mt-2 px-0">
                    <table
                      className={`table ${styles.tableListHeader}`}
                      id="tableListHeader"
                    >
                      <thead>
                        <tr>
                          <th id="th" style={{ width: "5% !important" }}>
                            <input
                              type="checkbox"
                              className={`${paginatedData?.some(
                                (io) => io.assign_status === 1
                              ) || paginatedData.length === 0
                                  ? "ListCheckbox align-text-bottom disabled_btn"
                                  : "ListCheckbox align-text-bottom"
                                } `}
                              disabled={
                                paginatedData?.some(
                                  (io) => io.assign_status === 1
                                ) || paginatedData.length === 0
                              }
                              checked={
                                selectedStudents?.length > 0 &&
                                  selectedStudents?.length ===
                                  paginatedData?.length
                                  ? true
                                  : false
                              }
                              onChange={(e) =>
                                handleTableCheckboxChangeAll(
                                  e,
                                  activeTab,
                                  paginatedData
                                )
                              }
                            />
                          </th>
                          <th id={`${styles.th}`}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "fullname", "stList")
                              }
                            >
                              Name
                            </span>
                            <span
                              className={`material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "fullname", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "admission_id", "stList")
                              }
                            >
                              Admission ID
                            </span>
                            <span
                              className={` material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "admission_id", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`}>
                            <span
                              className="text_th "
                              onClick={(e) => handleSort(e, "email", "stList")}
                            >
                              {" "}
                              Email ID
                            </span>
                            <span
                              className={` material-icons align-middle`}
                              onClick={(e) => handleSort(e, "email", "stList")}
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "phone_no", "stList")
                              }
                            >
                              Phone Number
                            </span>
                            <span
                              className={` material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "phone_no", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`} ref={filterRefAssign}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "assign_status", "stList")
                              }
                            >
                              Assign Status
                            </span>
                            <span
                              className={` material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "assign_status", "stList")
                              }
                            >
                              import_export
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${assignStatus.length > 0
                                  ? styles.active_icons
                                  : ""
                                } ${isOpen.assignStatus ? styles.active_icons : ""
                                }`} // Change here
                              onClick={(e) => handleFilter(e, "assignStatus")}
                            >
                              filter_list
                            </span>
                            {isOpen.assignStatus === true && (
                              <div className="filterBoxs_testlist">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        type="checkbox"
                                        className="ListCheckbox"
                                        name="NotYetAssigned"
                                        value="0"
                                        id="NotYetAssigned"
                                        checked={assignStatus.some(
                                          (element) => element.id === "0"
                                        )}
                                        onChange={handleCheckboxChange}
                                      />
                                      <label
                                        className="form-check-label filterChipText bg-pink"
                                        htmlFor="NotYetAssigned"
                                      >
                                        Not Yet Assigned
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        type="checkbox"
                                        className="ListCheckbox"
                                        name="Assigned"
                                        value="1"
                                        id="Assigned"
                                        checked={assignStatus.some(
                                          (element) => element.id === "1"
                                        )}
                                        onChange={handleCheckboxChange}
                                      />
                                      <label
                                        className="bg-green filterChipText form-check-label"
                                        htmlFor="Assigned"
                                      >
                                        Assigned To Evaluator
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleClear("assignStatus")
                                        }
                                        className="secondaryButton ms-2"
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter("assignStatus")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>

                          <th id={`${styles.th}`}>
                            <span className="text_th">Assigned To</span>
                            <span
                              className={`material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "staff_name", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`}>
                            <span className="text_th">Assigned Date</span>
                            <span
                              className={`material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "assign_date", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`} ref={filterRefEvaluate}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "evaluated_status", "stList")
                              }
                            >
                              Evaluation Status
                            </span>

                            <span
                              className={`textHead_th material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "evaluated_status", "stList")
                              }
                            >
                              import_export
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${evaluateStatus.length > 0
                                  ? styles.active_icons
                                  : ""
                                } ${isOpen.evaluateStatus ? styles.active_icons : ""
                                }`} // Change here
                              onClick={(e) => handleFilter(e, "evaluateStatus")}
                            >
                              filter_list
                            </span>
                            {isOpen.evaluateStatus === true && (
                              <div className="filterBoxs_testlist">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        type="checkbox"
                                        className="ListCheckbox"
                                        name="NotYetEvaluated"
                                        value="0"
                                        id="NotYetEvaluated"
                                        checked={evaluateStatus.some(
                                          (element) => element.id === "0"
                                        )}
                                        onChange={handleCheckboxChange}
                                      />
                                      <label
                                        className="form-check-label filterChipText bg-pink"
                                        htmlFor="NotYetEvaluated"
                                      >
                                        Not Yet Evaluated
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        type="checkbox"
                                        className="ListCheckbox"
                                        name="Evaluated"
                                        value="1"
                                        id="Evaluated"
                                        checked={evaluateStatus.some(
                                          (element) => element.id === "1"
                                        )}
                                        onChange={handleCheckboxChange}
                                      />
                                      <label
                                        className="bg-green filterChipText form-check-label"
                                        htmlFor="Evaluated"
                                      >
                                        Evaluated
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleClear("evaluateStatus")
                                        }
                                        className="secondaryButton ms-2"
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter("evaluateStatus")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>

                          <th id={`${styles.th}`}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "marks_obtained", "stList")
                              }
                            >
                              Obtained Marks
                            </span>
                            <span
                              className={` material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "marks_obtained", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "event_rank", "stList")
                              }
                            >
                              Class Rank
                            </span>
                            <span
                              className={` material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "event_rank", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`}>
                            <span
                              className="text_th"
                              onClick={(e) =>
                                handleSort(e, "over_all_event_rank", "stList")
                              }
                            >
                              Overall Rank
                            </span>
                            <span
                              className={` material-icons align-middle`}
                              onClick={(e) =>
                                handleSort(e, "over_all_event_rank", "stList")
                              }
                            >
                              import_export
                            </span>
                          </th>
                          <th id={`${styles.th}`}>
                            {" "}
                            <span className="text_th">Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData && paginatedData.length === 0 ? (
                          <tr>
                            <td
                              colSpan="15"
                              style={{
                                textAlign: "center",
                                borderBottom: "1px solid #dee2e6",
                              }}
                            >
                              No records to display
                            </td>
                          </tr>
                        ) : (
                          // Show only the active tab's data
                          paginatedData?.map((data, index) => (
                            <tr className={styles.rowHover} key={index}>
                              <td id={`${styles.td}`}>
                                <input
                                  type="checkbox"
                                  disabled={
                                    data.assign_staff_count ===
                                      data.assign_count &&
                                      data.assign_status !== 0
                                      ? true
                                      : false
                                  }
                                  className={`${data.assign_staff_count ===
                                      data.assign_count &&
                                      data.assign_status !== 0
                                      ? `${styles.ListCheckbox} disabled_btn`
                                      : `${styles.ListCheckbox}`
                                    }`}
                                  // value={selectedStudents.length > 0
                                  //   ? selectedStudents
                                  //   : ""}
                                  //   checked=
                                  value={selectedStudents}
                                  checked={selectedStudents.some(
                                    (student) =>
                                      student.user_id === data.user_id
                                  )}
                                  onChange={(e) =>
                                    handleTableCheckboxChange(
                                      e,
                                      data.user_id,
                                      data.stud_list_id,
                                      data.staff_name,
                                      data.batch_id,
                                      data.double_evaluation
                                    )
                                  }
                                />
                              </td>
                              <td id={`${styles.td}`}>{data.fullname}</td>
                              <td id={`${styles.td}`}>{data.admission_id}</td>
                              <td
                                className={styles.ellipsis}
                                title={data.email}
                                id={`${styles.td}`}
                              >
                                {data.email}
                              </td>
                              <td id={`${styles.td}`}>{data.phone_no}</td>

                              {data.assign_status === 0 && (
                                <td id={`${styles.td}`}>
                                  <span class="filterChipText bg-pink">
                                    Not Yet Assigned ({data.assign_staff_count}/
                                    {data.assign_count})
                                    {/* {data.double_evaluation === 0 ? 1 : 2} */}
                                  </span>
                                </td>
                              )}
                              {data.assign_status !== 0 && (
                                <td id={`${styles.td}`}>
                                  <span className="filterChipText bg-green">
                                    Assigned To Evaluator(
                                    {data.assign_staff_count}/
                                    {data.assign_count})
                                  </span>
                                </td>
                              )}
                              <td
                                className={styles.ellipsis}
                                title={
                                  data.staff_name && data.staff_name.length > 0
                                    ? data.staff_name
                                      .map((io) => io.staff_name)
                                      .join(", ")
                                    : "_"
                                }
                                id={`${styles.td}`}
                              >
                                {data.staff_name && data.staff_name.length > 0
                                  ? data.staff_name
                                    .map((io) => io.staff_name)
                                    .join(", ")
                                  : "_"}
                              </td>
                              <td id={`${styles.td}`}>
                                {data.assign_date
                                  ? moment(data.assign_date).format(
                                    "DD/MM/YYYY"
                                  )
                                  : "_"}
                              </td>
                              {/* <td id={`${styles.td}`}>22-10-2024</td> */}

                              {data.evaluated_status === 0 ? (
                                <td id={`${styles.td}`}>
                                  <span className={`${styles.PinkText}`}>
                                    Not Yet Evaluated (
                                    {data.evaluated_staff_count}/
                                    {data.assign_count})
                                  </span>
                                </td>
                              ) : (
                                <td id={`${styles.td}`}>
                                  <span className={`${styles.GreenTexts}`}>
                                    Evaluated({data.evaluated_staff_count}/
                                    {data.assign_count})
                                  </span>
                                </td>
                              )}
                              {/* {data.evaluated_status !== 0  && (
                          
                        )} */}
                              <td id={`${styles.td}`}>
                                {data.marks_obtained !== null ||
                                  data.marks_obtained === 0
                                  ? data.marks_obtained
                                  : "_"}
                              </td>
                              <td id={`${styles.td}`}>
                                {data.event_rank != null
                                  ? data.event_rank
                                  : "-"}
                              </td>
                              <td id={`${styles.td}`}>
                                {data.over_all_event_rank != null
                                  ? data.over_all_event_rank
                                  : "-"}
                              </td>

                              <td id={`${styles.td}`}>
                                <button
                                  className={`${styles.button}`}
                                  onClick={() =>
                                    handleStudentView(
                                      data.user_id,
                                      data.evaluator_count
                                    )
                                  }
                                >
                                  <span class="material-icons">visibility</span>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row mt-2 pb-3">
                  <Pagination
                    rowsPerPage={rowsPerPage}
                    handlePageCount={handlePageCount}
                    startPage={
                      totalRecords > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0
                    }
                    endPage={
                      totalRecords > 0
                        ? Math.min(currentPage * rowsPerPage, totalRecords)
                        : 0
                    }
                    totalRecords={totalRecords}
                    handlePrev={() =>
                      totalRecords > 0 &&
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    currentPrevPage={currentPage === 1 || totalRecords === 0}
                    prevButton={`${styles.prev_buttonViewTestList} me-2`}
                    handleNext={() =>
                      totalRecords > 0 &&
                      setCurrentPage((prev) =>
                        Math.min(
                          prev + 1,
                          Math.ceil(totalRecords / rowsPerPage)
                        )
                      )
                    }
                    currentNextPage={
                      currentPage === Math.ceil(totalRecords / rowsPerPage) ||
                      totalRecords === 0
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
          <div className="row m-0">
            <fieldset className="mt-3">
              <legend className="w-auto">Evaluator List</legend>

              {updateChipDatas.filter((kl) => kl.name !== "ActiveTab").length >
                0 ? (
                <div className="row mt-3">
                  <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {updateChipDatas
                        .filter((kl) => kl.name !== "ActiveTab")
                        .map((data, index) => {
                          // console.log(data, " - data - ", index);
                          let icon;
                          let key = "" + data.name;
                          return (
                            <ListItem key={data}>
                              <Chip
                                icon={icon}
                                label={key}
                                onDelete={handleDeletes(data, index)}
                              />
                            </ListItem>
                          );
                        })}

                      <ListItem className="clearAll_list">
                        <a
                          className="clearAll_listItem"
                          href="javascript:void(0)"
                          onClick={handleAllClears}
                        >
                          Clear All Filters
                        </a>
                      </ListItem>
                    </Paper>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div className="row mx-0">
                <div className="col-md-12 table-responsive tableMinHeight mt-2 px-0">
                  <table className="table" id="tableListHeader">
                    <thead>
                      <tr id="th">
                        <th id="th">
                          <span className="textHead_th">Name</span>
                          <span
                            className="textHead_th align-middle material-icons"
                            onClick={(e) =>
                              handleSort(e, "full_name", "evList")
                            }
                          >
                            import_export
                          </span>
                        </th>

                        <th id="th">
                          <span className="textHead_th "> Email ID</span>
                          <span
                            className="textHead_th align-middle material-icons"
                            onClick={(e) => handleSort(e, "email", "evList")}
                          >
                            import_export
                          </span>
                        </th>
                        <th id="th">
                          <span className="textHead_th">Phone Number</span>
                          <span
                            className="textHead_th align-middle material-icons"
                            onClick={(e) =>
                              handleSort(e, "mobile_no", "evList")
                            }
                          >
                            import_export
                          </span>
                        </th>
                        <th id="th">
                          <span className="textHead_th">
                            Number of Answer Sheets Assigned
                          </span>
                          <span
                            className="textHead_th align-middle material-icons"
                            onClick={(e) =>
                              handleSort(e, "total_students", "evList")
                            }
                          >
                            import_export
                          </span>
                        </th>

                        <th id="th" ref={filterRef}>
                          <span className="textHead_th">Due Date</span>
                          <span
                            className="textHead_th align-middle material-icons"
                            onClick={(e) => handleSort(e, "due_date", "evList")}
                          >
                            import_export
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${appOn.length > 0 ? styles.active_icons : ""
                              } ${isOpen.dueDate ? styles.active_icons : ""}`} // Change here
                            onClick={(e) => handleFilter(e, "dueDate")}
                          >
                            filter_list
                          </span>
                          {isOpen.dueDate === true && (
                            <div className="filterBoxs_testlist">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul class="ulFilterListData mb-2">
                                  <li class="filterListData ">
                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value me-1"
                                    >
                                      From Date
                                    </label>
                                    <DatePickerSample
                                      IconInput={"LI_filterIocnBoxInput"}
                                      class={"LI_FilterInputs"}
                                      name={"FDate"}
                                      handleChange={handleChangeDate}
                                      fieldInput={appData.FDate}
                                      minDate={
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() + 1
                                          )
                                        )
                                      } // Minimum date is tomorrow
                                      txtAdMDob={txtEvDuedate}
                                    />
                                  </li>
                                  {errors.FDate && (
                                    <small className="text-danger">
                                      {errors.FDate}
                                    </small>
                                  )}
                                  <li class="filterListData">
                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value me-1"
                                    >
                                      To Date
                                    </label>
                                    <DatePickerSample
                                      class={"LI_FilterInputs"}
                                      IconInput={"LI_filterIocnBoxInput"}
                                      name={"TDate"}
                                      minDate={
                                        new Date(
                                          new Date().setDate(
                                            new Date().getDate() + 1
                                          )
                                        )
                                      } // Minimum date is tomorrow
                                      handleChange={handleChangeDate}
                                      fieldInput={appData.TDate}
                                      txtAdMDob={txtEvTDuedate}
                                    />
                                  </li>
                                  {errors.TDate && (
                                    <small className="text-danger">
                                      {errors.TDate}
                                    </small>
                                  )}
                                </ul>
                                <ul
                                  class="ulFilterListData borderWidth"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <li class="filterListData filterRadioInput    col-6">
                                    <input
                                      type="radio"
                                      className="ListCheckbox"
                                      id="Today"
                                      name="Days"
                                      value="Today"
                                      checked={appData.Days === "Today"}
                                      onChange={handleRadioChange}
                                    />
                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value "
                                      for="Today"
                                    >
                                      Today
                                    </label>
                                  </li>
                                  <li class="filterListData filterRadioInput col-6">
                                    <input
                                      type="radio"
                                      className="ListCheckbox"
                                      name="Days"
                                      value="Yesterday"
                                      id="Yesterday"
                                      checked={appData.Days === "Yesterday"}
                                      onChange={handleRadioChange}
                                    />

                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value"
                                      for="Yesterday"
                                    >
                                      Yesterday
                                    </label>
                                  </li>
                                </ul>
                                <ul
                                  class="ulFilterListData"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <li class="filterListData filterRadioInput col-6 ">
                                    <input
                                      type="radio"
                                      className="ListCheckbox"
                                      name="Days"
                                      value="Tweek"
                                      id="Tweek"
                                      checked={appData.Days === "Tweek"}
                                      onChange={handleRadioChange}
                                    />
                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value"
                                      for="Tweek"
                                    >
                                      This Week
                                    </label>
                                  </li>
                                  <li class="filterListData filterRadioInput col-6 ">
                                    <input
                                      type="radio"
                                      className="ListCheckbox"
                                      name="Days"
                                      value="Lweek"
                                      id="lastWeek"
                                      onChange={handleRadioChange}
                                      checked={appData.Days === "Lweek"}
                                    />

                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value"
                                      for="lastWeek"
                                    >
                                      Last Week
                                    </label>
                                  </li>
                                </ul>
                                <ul
                                  class="ulFilterListData"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <li class="filterListData filterRadioInput col-6 ">
                                    <input
                                      type="radio"
                                      className="ListCheckbox"
                                      name="Days"
                                      value="Tmonth"
                                      id="month"
                                      onChange={handleRadioChange}
                                      checked={appData.Days === "Tmonth"}
                                    />
                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value"
                                      for="month"
                                    >
                                      This Month
                                    </label>
                                  </li>
                                  <li class="filterListData filterRadioInput col-6 ">
                                    <input
                                      type="radio"
                                      className="ListCheckbox"
                                      name="Days"
                                      value="Lmonth"
                                      id="lastMonth"
                                      checked={appData.Days === "Lmonth"}
                                      onChange={handleRadioChange}
                                    />

                                    <label
                                      htmlFor="startDate"
                                      class="form-label confirm_value"
                                      for="lastMonth"
                                    >
                                      Last Month
                                    </label>
                                  </li>
                                </ul>
                              </div>

                              <div className=" borderWidth row">
                                <ul className="List-Button">
                                  <li class="ListBtnItems">
                                    <Link
                                      onClick={() => handleClears("dueDate")}
                                      className="secondaryButton ms-2"
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li class="ListBtnItems">
                                    <Link
                                      onClick={() =>
                                        handleApplyFilters("dueDate")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}
                        </th>

                        <th id="th">
                          <span className="textHead_th">Status</span>
                          <span
                            className="textHead_th align-middle material-icons"
                            onClick={(e) =>
                              handleSort(e, "evaluated_status", "evList")
                            }
                          >
                            import_export
                          </span>
                        </th>
                        <th id="th">
                          <span className="textHead_th">Action</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentDatas && currentDatas?.length === 0 ? (
                        <tr>
                          <td
                            colSpan="15"
                            style={{
                              textAlign: "center",
                              borderBottom: "1px solid #dee2e6",
                            }}
                          >
                            No records to display
                          </td>
                        </tr>
                      ) : (
                        currentDatas?.map((course, index) => (
                          <tr className={styles.rowHover} key={index}>
                            <td id={`${styles.td}`}>
                              {" "}
                              {course.status === 1 && (
                                <div className="global_dot_chat"></div>
                              )}
                              {course.full_name}
                            </td>
                            <td
                              className={styles.ellipsis}
                              title={course.email}
                              id={`${styles.td}`}
                            >
                              {course.email}
                            </td>
                            <td id={`${styles.td}`}>{course.mobile_no}</td>

                            <td id={`${styles.td}`}>{course.total_students}</td>
                            <td id={`${styles.td}`}>
                              {course.due_date
                                ? moment(course.due_date).format("DD/MM/YYYY")
                                : "_"}
                            </td>
                            {course.evaluated_students !==
                              course.total_students ? (
                              <td id={`${styles.td}`}>
                                <span className={`${styles.PinkText}`}>
                                  {`Not Yet Evaluated (${course.evaluated_students}/${course.total_students})`}
                                </span>
                              </td>
                            ) : (
                              <td id={`${styles.td}`}>
                                <span className={`${styles.GreenTexts}`}>
                                  {`Evaluated (${course.evaluated_students}/${course.total_students})`}
                                </span>
                              </td>
                            )}

                            <td id={`${styles.td}`}>
                              <button
                                onClick={() =>
                                  handleEvaluvatorReadView(
                                    course.full_name,
                                    course.event_id,
                                    course.id,
                                    course.add_more_status,
                                    course.evaluator_count
                                  )
                                }
                                className={`view_icon_button d-flex`}
                              >
                                <span className={` visibleicon material-icons`}>
                                  visibility
                                </span>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row mt-2 pb-3">
                <Pagination
                  rowsPerPage={rowsPerPages}
                  handlePageCount={handlePageCounts}
                  startPage={
                    currentDatas && currentDatas.length > 0
                      ? currentPages * rowsPerPages + 1 - rowsPerPages
                      : 0
                  }
                  endPage={
                    currentDatas && currentDatas.length > 0
                      ? Math.min(
                        currentDatas.length,
                        currentPages * rowsPerPages
                      )
                      : 0
                  }
                  totalRecords={filteredData?.length || 0}
                  handlePrev={(e) => {
                    if (currentPages > 1) handlePrevs(currentPages - 1);
                  }}
                  currentPrevPage={currentPages === 1}
                  prevButton={`${styles.prev_buttonViewTestList}  me-2`}
                  handleNext={() => {
                    if (currentPages < totalPages_de)
                      handleNexts(currentPages + 1);
                  }}
                  currentNextPage={currentPages >= totalPages_de} // Ensures it's disabled when no more pages
                  onContextMenu={(e) => e.preventDefault()} // Disables right-click
                />
              </div>
            </fieldset>
          </div>

          {open && (
            <Modal
              key={`modal-0-${0}`}
              show={open}
              onHide={handleModelClose}
              size="xl"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <h5
                    className={`${styles.view_title} fw-bold mb-0`}
                    id="exampleModalLabel"
                  >
                    Assign to Evaluators
                  </h5>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row global_container">
                  <div className="col-12">
                    <form className="row g-3">
                      {/* Evaluator Name Dropdown */}
                      <div className="col-md-4">
                        <label
                          htmlFor="chooseTest"
                          className="form-label confirm_value"
                        >
                          Evaluator Name
                        </label>
                        <Select
                          className="shadow-none input-font-size"
                          placeholder="Select Evaluator Name"
                          isClearable
                          name="evaluatorName"
                          value={dropdownValue}
                          options={groupedOptions}
                          styles={customStyles} // Apply custom styles her
                          onChange={(selectedOption) =>
                            handleSelectChange(selectedOption, "evaluatorName")
                          }
                        />
                        {error.evaluatorName && (
                          <small className="error_message">
                            {error.evaluatorName}
                          </small>
                        )}
                      </div>

                      {/* Due Date DatePicker */}
                      <div className="col-md-4">
                        <div className="forms">
                          <label
                            htmlFor="startDate"
                            className="form-label confirm_value"
                          >
                            Due Date
                          </label>
                          <DatePickerSample
                            handleYearChange={handleYearChange}
                            handleMonthChange={handleMonthChange}
                            minDate={
                              new Date(
                                new Date().setDate(new Date().getDate() + 1)
                              )
                            } // Minimum date is tomorrow
                            datePickerInputIcon="datePickerInputIcon"
                            datePickerInput="datePickerInput"
                            styles={{
                              position: "relative",
                              top: "5px",
                              cursor: "pointer",
                              right: "25px",
                              color: "var(--bluebrand)",
                              opacity: 1,
                              fontSize: "22px",
                            }}
                            leftStyles={{
                              margin: "10px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            txtAdMDob={txtAdMDob}
                            name="eventDate1"
                            handleChange={handleChangeDates}
                            fieldInput={
                              list.eventDate1
                                ? moment(list.eventDate1).format("DD-MM-YYYY")
                                : ""
                            }
                          />
                          {error.eventDate1 && (
                            <small className="error_message">
                              {error.eventDate1}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="mt-3 col-md-4">
                        <div className="d-flex flex-column mt-2">
                          <p className="confirm_label mb-1 p-0">
                            Number of Answer Sheets Assigned Already
                          </p>
                          {evaluatorList?.length > 0 &&
                            evaluatorList.map((item) => (
                              <p
                                className="confirm_value m-0 p-0"
                                key={item.staff_id}
                              >
                                {item.total_assigned_students || "-"}
                              </p>
                            ))}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <ul className="List-Button">
                  <li className="ListBtnItems">
                    <Link onClick={handleClose} className="primaryButton">
                      Assign Now
                    </Link>
                  </li>
                </ul>
              </Modal.Footer>
            </Modal>
          )}

          {open_doubleeva && (
            <Modal
              key={`modal-1-${1}`}
              show={open_doubleeva}
              onHide={handleModelClose_des}
              size="xl"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <h5
                    className={`${styles.view_title} fw-bold mb-0`}
                    id="exampleModalLabel"
                  >
                    Assign to Evaluators
                  </h5>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row global_container">
                  <div className="col-12">
                    <form className="row g-3">
                      {/* Evaluator Name 1 Dropdown */}
                      <div className="col-md-4">
                        <label
                          htmlFor="chooseTest"
                          className="form-label confirm_value"
                        >
                          Evaluator Name 1
                        </label>
                        <Select
                          className={`shadow-none input-font-size ${statusRetained ? "disabled_Name" : ""
                            }`}
                          isDisabled={statusRetained}
                          placeholder="Select Evaluator Name"
                          isClearable
                          name="evaluatorName1"
                          value={dropdownValue1}
                          options={groupedOptions}
                          styles={customStyles} // Apply custom styles her
                          onChange={(selectedOption) =>
                            handleSelectChange(selectedOption, "evaluatorName1")
                          }
                        />

                        {error.evaluatorName1 && (
                          <small className="error_message">
                            {error.evaluatorName1}
                          </small>
                        )}
                      </div>
                      <div className="col-md-4">
                        <div className="forms ">
                          <label
                            htmlFor="eventDate"
                            class="form-label confirm_value"
                          >
                            Due Date
                          </label>
                          <DatePickerSample
                            class={` ${statusRetained ? "Inputs disabled_btn" : "Inputs"
                              }`}
                            disabledProperty={
                              statusRetained === true ? true : false
                            }
                            minDate={
                              new Date(
                                new Date().setDate(new Date().getDate() + 1)
                              )
                            } // Minimum date is tomorrow
                            handleYearChange={handleYearChange}
                            handleMonthChange={handleMonthChange}
                            datePickerInputIcon="datePickerInputIcon"
                            datePickerInput="datePickerInput"
                            txtAdMDob={txtAdMDob_evone}
                            name={"eventDate"}
                            styles={{
                              position: "relative",
                              top: "5px",
                              cursor: "pointer",
                              right: "25px",
                              color: "var(--bluebrand)",
                              opacity: 1,
                              fontSize: "22px",
                            }}
                            className={`shadow-none input-font-size ${statusRetained ? "disabled_btn" : ""
                              }`}
                            isDisabled={statusRetained}
                            leftStyles={{
                              margin: "10px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            handleChange={handleChangeDates}
                            fieldInput={
                              list.eventDate
                                ? moment(list.eventDate).format("DD-MM-YYYY")
                                : ""
                            }
                          />
                          {error.eventDate && (
                            <small className="error_message">
                              {error.eventDate}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="mt-3 col-md-4">
                        <div className="d-flex flex-column mt-2">
                          <p className="confirm_label mb-1 p-0">
                            Number of Answer Sheets Assigned Already
                          </p>

                          {evaluatorList1?.length > 0 ? (
                            evaluatorList1.map((item) => {
                              return (
                                <p
                                  className="confirm_value m-0 p-0"
                                  key={item.staff_id}
                                >
                                  {item.total_assigned_students || "-"}{" "}
                                  {/* Show '-' if total_assigned_students is empty or undefined */}
                                </p>
                              );
                            })
                          ) : (
                            <div className="mt-3 col-md-6">
                              <div className="d-flex flex-column mt-2">
                                <p className="confirm_value m-0 p-0">-</p>{" "}
                                {/* Default message when the array is empty */}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Evaluator Name 2 Dropdown */}
                      <div className="col-md-4">
                        <label
                          htmlFor="chooseTest"
                          className="form-label confirm_value"
                        >
                          Evaluator Name 2
                        </label>
                        <Select
                          className={`shadow-none input-font-size ${statusRetained1 ? "disabled_Name" : ""
                            }`}
                          isDisabled={statusRetained1} // Use isDisabled instead of disabled
                          placeholder="Select Evaluator Name"
                          isClearable
                          name="evaluatorName2"
                          value={dropdownValue2}
                          options={groupedOptions}
                          onChange={(selectedOption) =>
                            handleSelectChange(selectedOption, "evaluatorName2")
                          }
                          styles={customStyles} // Apply custom styles her
                        />

                        {error.evaluatorName2 && (
                          <small className="error_message">
                            {error.evaluatorName2}
                          </small>
                        )}
                      </div>

                      {/* Due Date DatePicker */}
                      <div className="col-md-4">
                        <div className="forms ">
                          <label
                            htmlFor="eventDate"
                            class="form-label confirm_value"
                          >
                            Due Date
                          </label>
                          <DatePickerSample
                            class={` ${statusRetained1 ? "Inputs disabled_btn" : "Inputs"
                              }`}
                            disabledProperty={
                              statusRetained1 === true ? true : false
                            }
                            minDate={
                              new Date(
                                new Date().setDate(new Date().getDate() + 1)
                              )
                            } // Minimum date is tomorrow
                            handleYearChange={handleYearChange}
                            handleMonthChange={handleMonthChange}
                            datePickerInputIcon="datePickerInputIcon"
                            datePickerInput="datePickerInput"
                            txtAdMDob={txtAdMDob_evtwo}
                            name={"eventDate2"}
                            styles={{
                              position: "relative",
                              top: "5px",
                              cursor: "pointer",
                              right: "25px",
                              color: "var(--bluebrand)",
                              opacity: 1,
                              fontSize: "22px",
                            }}
                            className={`shadow-none input-font-size ${statusRetained1 ? "disabled_btn" : ""
                              }`}
                            isDisabled={statusRetained1}
                            leftStyles={{
                              margin: "10px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            handleChange={handleChangeDates}
                            fieldInput={
                              list.eventDate2
                                ? moment(list.eventDate2).format("DD-MM-YYYY")
                                : ""
                            }
                          />
                          {error.eventDate2 && (
                            <small className="error_message">
                              {error.eventDate2}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="mt-3 col-md-4">
                        <div className="d-flex flex-column mt-2">
                          <p className="confirm_label mb-1 p-0">
                            Number of Answer Sheets Assigned Already
                          </p>
                          {evaluatorList2?.length > 0 ? (
                            evaluatorList2.map((item) => (
                              <p
                                className="confirm_value m-0 p-0"
                                key={item.staff_id}
                              >
                                {item.total_assigned_students || "-"}
                              </p>
                            ))
                          ) : (
                            <p className="confirm_value m-0 p-0">-</p>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <ul className="List-Button">
                  <li className="ListBtnItems">
                    <Link onClick={handleClose} className="primaryButton">
                      Assign Now
                    </Link>
                  </li>
                </ul>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      )}
      {fdata.event_type == 0 && (
        <div className="row mx-0 mt-3 mb-4">
          <div className="col-xl-12 col-lg-12 col-md-12 col-12 px-0">
            <fieldset className={ViewBookSet.preorderContainer}>
              <legend className="w-auto mb-0">Class Attendance</legend>
              <div className="row mx-0 ">
                <div className="col-lg-4 col-md-4 mb-3 col-sm-12 col-xs-12 px-0">
                  <div class={ViewBookSet.searchInputSec}>
                    <input
                      className={`${ViewBookSet.searchInput} w-100`}
                      type="text"
                      placeholder="Search by Student Name"
                      name="search_book_title"
                      onKeyDown={handleSearch}
                      ref={txtBSearch}
                    />
                    <Search
                      onClick={handleSearchFocus}
                      className={`${ViewBookSet.ListsearchIcon}`}
                    />
                  </div>
                </div>

                <div className="col-md-8 col-12 ListBtn px-0">
                  <ul class="List-Button">
                    <li class="ListBtnItems">
                      <CustomDownloadButton
                        csvListData={
                          updateListData?.length > 0 ? updateListData : ""
                        }
                        iconName=" file_download "
                        filename={"IndiviualsBook.csv"}
                        csvName="  Download as CSV"
                      />
                    </li>
                    <li
                      class="ListBtnItems primaryButton"
                      onClick={generatePDF}
                    >
                      <span className="material-icons me-1 align-middle text-white">
                        file_download
                      </span>
                      Download as PDF
                    </li>
                  </ul>
                </div>
              </div>
              {updateChipData1?.length > 0 ? (
                <div className="row mt-3">
                  <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {updateChipData1.map((data, index) => {
                        let icon;
                        let key = "" + data.name;
                        return (
                          <ListItem key={data}>
                            <Chip
                              icon={icon}
                              label={key}
                              onDelete={handleDelete1(data, index)}
                            />
                          </ListItem>
                        );
                      })}
                      <ListItem className="clearAll_list">
                        <a
                          className="clearAll_listItem"
                          href="javascript:void(0)"
                          onClick={handleAllClear1}
                        >
                          Clear All Filters
                        </a>
                      </ListItem>
                    </Paper>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div className="row mx-0 mt-2">
                <div
                  className={`col-md-12 ${ViewBookSet.table_responsive_padding} table-responsive tableMinHeight px-0 `}
                >
                  <table className="" id="tableListHeader">
                    <thead>
                      <tr>
                        <th id="th" className={ViewBookSet.tableThPadding}>
                          <span
                            onClick={(e) =>
                              handleSort(e, "serialNumber", "atenList")
                            }
                            className="textHead_th"
                          >
                            S.No.
                          </span>
                          <span
                            onClick={(e) =>
                              handleSort(e, "serialNumber", "atenList")
                            }
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={ViewBookSet.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "name", "atenList")}
                            className="textHead_th"
                          >
                            Student Name
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "name", "atenList")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>

                        {/* <th id="th" className={ViewBookSet.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "email", "atenList")}
                            className="textHead_th"
                          >
                            Email
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "email", "atenList")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={ViewBookSet.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "phone_no", "atenList")}
                            className="textHead_th"
                          >
                            Phone Number
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "phone_no", 'atenList')}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th> */}
                        <th
                          id="th"
                          className={ViewBookSet.tableThPadding}
                          ref={filterRef_batch_name}
                        >
                          <span
                            onClick={(e) =>
                              handleSort(e, "batch_name", "atenList")
                            }
                            className="textHead_th"
                          >
                            Batch Name
                          </span>
                          <span
                            onClick={(e) =>
                              handleSort(e, "batch_name", "atenList")
                            }
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${batch_name.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                              } ${isOpen.batch_name
                                ? ViewBookSet.active_icons_book
                                : ""
                              }`}
                            onClick={(e) => handleFilter1(e, "batch_name")}
                          >
                            filter_list
                          </span>
                          {isOpen.batch_name && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li
                                      className={`filterListData ${ViewBookSet.searchInputSec}`}
                                    >
                                      <input
                                        className={`${ViewBookSet.searchInput} w-100`}
                                        type="text"
                                        placeholder="Search by batch name"
                                        name="search_batch_name"
                                        onChange={(e) =>
                                          handleFilterCourseSearch(
                                            e,
                                            "batch_name"
                                          )
                                        }
                                        ref={txtBSearch_batch_name}
                                      />
                                      <Search
                                        onClick={() =>
                                          handleFilterSearchFocus("batch_name")
                                        }
                                        className={`${ViewBookSet.ListsearchIcon}`}
                                      />
                                    </li>
                                    {batchList.map((el) => (
                                      <>
                                        <li className="filterListData">
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={el.batch_name}
                                            value={el.batch_id}
                                            id={el.batch_name}
                                            checked={batch_name.some(
                                              (element) => {
                                                if (
                                                  element.name == el.batch_name
                                                ) {
                                                  return true;
                                                }
                                                return false;
                                              }
                                            )}
                                            onChange={(e) =>
                                              handleCheckboxChange1(
                                                e,
                                                el.batch_name,
                                                "batch_name"
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG "
                                            htmlFor={el.batch_name}
                                          >
                                            {el.batch_name}
                                          </label>
                                        </li>
                                      </>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear1("batch_name")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter1("batch_name")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                        <th
                          id="th"
                          className={ViewBookSet.tableThPadding}
                          ref={filterRef_section}
                        >
                          <span
                            onClick={(e) =>
                              handleSort(e, "section", "atenList")
                            }
                            className="textHead_th"
                          >
                            Section
                          </span>
                          <span
                            onClick={(e) =>
                              handleSort(e, "section", "atenList")
                            }
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${section.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                              } ${isOpen.section
                                ? ViewBookSet.active_icons_book
                                : ""
                              }`}
                            onClick={(e) => handleFilter1(e, "section")}
                          >
                            filter_list
                          </span>

                          {isOpen.section && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    {sectionList.map((el) => (
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.section}
                                          value={el.id}
                                          id={el.section}
                                          checked={section.some((element) => {
                                            if (element.name == el.section) {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          onChange={(e) =>
                                            handleCheckboxChange1(
                                              e,
                                              el.section,
                                              "section"
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.section}
                                        >
                                          {el.section}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear1("section")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter1("section")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                        <th
                          id="th"
                          className={ViewBookSet.tableThPadding}
                          ref={filterRef_medium}
                        >
                          <span
                            onClick={(e) => handleSort(e, "medium", "atenList")}
                            className="textHead_th"
                          >
                            Medium
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "medium", "atenList")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${medium_on.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                              } ${isOpen.medium ? ViewBookSet.active_icons_book : ""
                              }`}
                            onClick={(e) => handleFilter1(e, "medium")}
                          >
                            filter_list
                          </span>
                          {isOpen.medium && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Tamil"}
                                        value={"0"}
                                        checked={medium_on.some((element) => {
                                          if (element.id == "0") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"Tamil"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "medium",
                                            "medium"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"Tamil"}
                                      >
                                        Tamil
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"English"}
                                        value={"1"}
                                        checked={medium_on.some((element) => {
                                          if (element.id == "1") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"English"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "medium",
                                            "medium"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"English"}
                                      >
                                        English
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear1("medium")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          medium_on.length === 0 ? true : false
                                        }
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter1("medium")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                        <th
                          id="th"
                          className={ViewBookSet.tableThPadding}
                          ref={filterRef_class_mode}
                        >
                          <span
                            onClick={(e) =>
                              handleSort(e, "class_mode", "atenList")
                            }
                            className="textHead_th"
                          >
                            Class Mode
                          </span>
                          <span
                            onClick={(e) =>
                              handleSort(e, "class_mode", "atenList")
                            }
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${classMode.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                              } ${isOpen.class_mode
                                ? ViewBookSet.active_icons_book
                                : ""
                              }`}
                            onClick={(e) => handleFilter1(e, "class_mode")}
                          >
                            filter_list
                          </span>
                          {isOpen.class_mode && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Online"}
                                        value={"0"}
                                        checked={classMode.some((element) => {
                                          if (element.id == "0") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"Online"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "class_mode",
                                            "class_mode"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"Online"}
                                      >
                                        Online
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Classroom"}
                                        value={"1"}
                                        checked={classMode.some((element) => {
                                          if (element.id == "1") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"Classroom"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "class_mode",
                                            "class_mode"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"Classroom"}
                                      >
                                        Classroom
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleClear1("class_mode")
                                        }
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          classMode.length === 0 ? true : false
                                        }
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter1("class_mode")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                        <th
                          id="th"
                          className={ViewBookSet.tableThPadding}
                          ref={filterRef_schedule}
                        >
                          <span
                            onClick={(e) =>
                              handleSort(e, "schedule", "atenList")
                            }
                            className="textHead_th"
                          >
                            Schedule Preference
                          </span>
                          <span
                            onClick={(e) =>
                              handleSort(e, "schedule", "atenList")
                            }
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${schedule.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                              } ${isOpen.schedule
                                ? ViewBookSet.active_icons_book
                                : ""
                              }`}
                            onClick={(e) => handleFilter1(e, "schedule")}
                          >
                            filter_list
                          </span>
                          {isOpen.schedule && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Weekend"}
                                        value={"0"}
                                        checked={schedule.some((element) => {
                                          if (element.id == "0") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"Weekend"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "schedule",
                                            "schedule"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"Weekend"}
                                      >
                                        Weekend
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Regular"}
                                        value={"1"}
                                        checked={schedule.some((element) => {
                                          if (element.id == "1") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"Regular"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "schedule",
                                            "schedule"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"Regular"}
                                      >
                                        Regular
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear1("schedule")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          schedule.length === 0 ? true : false
                                        }
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter1("schedule")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                        <th
                          id="th"
                          className={ViewBookSet.tableThPadding}
                          ref={filterRef_location}
                        >
                          <span
                            onClick={(e) =>
                              handleSort(e, "location", "atenList")
                            }
                            className="textHead_th"
                          >
                            Location
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "location")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${locations.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                              } ${isOpen.location
                                ? ViewBookSet.active_icons_book
                                : ""
                              }`}
                            onClick={(e) => handleFilter1(e, "location")}
                          >
                            filter_list
                          </span>
                          {isOpen.location && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    {locationsId.map((el) => (
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.name}
                                          value={el.id}
                                          id={el.name}
                                          checked={locations.some((element) => {
                                            if (element.id == el.id) {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          onChange={(e) =>
                                            handleCheckboxChange1(
                                              e,
                                              el.name,
                                              "location"
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.name}
                                        >
                                          {el.name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear1("location")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          locations.length === 0 ? true : false
                                        }
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter1("location")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                        <th
                          id="th"
                          className={ViewBookSet.tableThPadding}
                          ref={filterRef_status}
                        >
                          <span
                            onClick={(e) => handleSort(e, "medium", "atenList")}
                            className="textHead_th"
                          >
                            Status
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "medium", "atenList")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${status_on.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                              } ${isOpen.status ? ViewBookSet.active_icons_book : ""
                              }`}
                            onClick={(e) => handleFilter1(e, "status")}
                          >
                            filter_list
                          </span>
                          {isOpen.status && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Present"}
                                        value={1}
                                        checked={status_on.some((element) => {
                                          if (element.id == 1) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"Present"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "status",
                                            "status"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"Present"}
                                      >
                                        Present
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Absent"}
                                        value={0}
                                        checked={status_on.some((element) => {
                                          if (element.id == 0) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        id={"Absent"}
                                        onChange={(e) =>
                                          handleCheckboxChange1(
                                            e,
                                            "status",
                                            "status"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"Absent"}
                                      >
                                        Absent
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear1("status")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          status_on.length === 0 ? true : false
                                        }
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleApplyFilter1("status")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData1?.length === 0 ? (
                        <tr>
                          <td colspan="15" style={{ textAlign: "center" }}>
                            No records to display
                          </td>
                        </tr>
                      ) : (
                        currentData1?.map((kl, ind) => (
                          <tr key={ind}>
                            <td id="td">{kl.serialNumber}</td>
                            <td id="td">
                              <span
                                title={kl.name}
                                className={ViewBookSet.ellipsisText}
                              >
                                {kl.name}
                              </span>
                            </td>
                            {/* <td id="td">
                              {" "}
                              <span
                                title={kl.email}
                                className={ViewBookSet.ellipsisText}
                              >
                                {kl.email ? kl.email : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={kl.phone_no}
                                className={ViewBookSet.ellipsisText}
                              >
                                {kl.phone_no ? kl.phone_no : "_"}
                              </span>
                            </td> */}
                            <td id="td">
                              {kl.batch_name ? kl.batch_name : "_"}
                            </td>
                            <td id="td">{kl.section ? kl.section : "_"}</td>
                            <td id="td">{kl.medium ? kl.medium : "_"}</td>
                            <td id="td">
                              {kl.class_mode ? kl.class_mode : "_"}
                            </td>
                            <td id="td">
                              {kl.batch_type ? kl.batch_type : "_"}
                            </td>
                            <td id="td">{kl.location ? kl.location : "_"}</td>
                            <td id="td">
                              {kl.status == 0 ? "Absent" : "Present"}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row mt-2">
                <Pagination
                  rowsPerPage={rowsPerPage1}
                  handlePageCount={handlePageCount1}
                  startPage={
                    updateListData && updateListData?.length > 0
                      ? currentPage1 * rowsPerPage1 + 1 - rowsPerPage1
                      : 0
                  }
                  endPage={
                    updateListData && updateListData?.length > 0
                      ? updateListData?.length < currentPage1 * rowsPerPage1
                        ? updateListData?.length
                        : currentPage1 * rowsPerPage1
                      : 0
                  }
                  totalRecords={
                    updateListData && updateListData?.length > 0
                      ? updateListData?.length
                      : 0
                  }
                  handlePrev={(e) => handlePrev1(currentPage1 - 1)}
                  currentPrevPage={currentPage1 === 1}
                  prevButton={`${ViewBookSet.prev_buttonViewAllbook} ${ViewBookSet.materialIconsRightAndLeft} me-2`}
                  handleNext={() => handleNext1(currentPage1 + 1)}
                  currentNextPage={
                    totalPages1 == 0 || currentPage1 === totalPages1
                  }
                />
              </div>
            </fieldset>
          </div>
        </div>
      )}

      {opens && (
        <Modal
          key={`modal-0-${0}`}
          show={opens}
          onHide={handleModalClose}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h5 className={` fw-bold mb-0`} id="exampleModalLabel">
                Recording Url and Attendees
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row global_container">
              <div className="col-12">
                <form className="row g-3">
                  {/* Evaluator Name Dropdown */}
                  <div className="col-md-6">
                    <label
                      htmlFor="chooseTest"
                      className="form-label confirm_value"
                    >
                      Recording Url
                    </label>
                    <input
                      className="desc_input_text w-100 rounded-2 input-font-size-sm"
                      type="text"
                      id="iframe"
                      name="iframe"
                      placeholder="Enter Recording URL"
                      value={fdata.iframe || ""}
                      onChange={handleChange1}
                    />
                    {/* {error.evaluatorName && (
                                          <small className="error_message">
                                            {error.evaluatorName}
                                          </small>
                                        )} */}
                  </div>

                  {/* Due Date DatePicker */}
                  <div className="col-md-6">
                    <div className="forms">
                      <label
                        htmlFor="startDate"
                        className="form-label confirm_value"
                      >
                        Attendance Sheet
                      </label>
                      <input
                        ref={answer_sheet_ref}
                        // className={
                        //   fdata.attendance_sheet_path !== "" &&
                        //     fdata.attendance_sheet_path !== null
                        //     ? "InputsSelectFile nn_upload_width"
                        //     : "InputsSelectFile  vv_upload_width"
                        // }
                        className={"InputsSelectFile  mt-0 vv_upload_width"}
                        type="file"
                        id="formFile"
                        name="AttendancesheetPath"
                        onChange={handleChange1}
                        required
                      />
                      {error.AttendancesheetPath && (
                        <small className="error_message">
                          {error.AttendancesheetPath}
                        </small>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ul className="List-Button">
              <li className="ListBtnItems">
                <button
                  onClick={handleClose1}
                  className="primaryButton border-0"
                >
                  Save
                </button>
              </li>
            </ul>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
